<template>
  <div>
    <div>
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1" @click="previousClick()">
            <span v-if="$vuetify.breakpoint.mdAndUp">Proposed Insureds</span>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2" @click="switchStep(2)">
            <span v-if="$vuetify.breakpoint.mdAndUp">Product Selection</span>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3" @click="switchStep(3)">
            <span v-if="$vuetify.breakpoint.mdAndUp">Coverage Questions</span>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 4" step="4" @click="switchStep(4)">
            <span v-if="$vuetify.breakpoint.mdAndUp">Rate Calculator</span>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 5" step="5" @click="switchStep(5)">
            <span v-if="$vuetify.breakpoint.mdAndUp">Rate Summary</span>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 6" step="6" @click="switchStep(6)">
            <span v-if="$vuetify.breakpoint.mdAndUp">Next Steps</span>
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1"></v-stepper-content>

          <!-- Product Selection -->

          <!-- smAndDown -->
          <v-stepper-content step="2" v-if="$vuetify.breakpoint.smAndDown">
            <v-layout justify-center align-content-center column>
              <br />
              <v-layout justify-center align-content-center>
                <span style="color: #00558c"
                  >Please select the coverage(s) you are interested in for each
                  proposed insured:</span
                >
                <br />
                <br />
                <br />
              </v-layout>
              <v-layout
                v-for="eachPerson of storedPersons"
                :key="eachPerson.id"
              >
                <v-flex>
                  <v-data-table
                    :class="
                      $vuetify.breakpoint.xs
                        ? 'fb-table-elem productTableXs text-wrap'
                        : 'fb-table-elem'
                    "
                    :headers="filteredHeaders(eachPerson)"
                    :items="filteredProductRows(eachPerson)"
                    hide-actions
                    item-key="index"
                    expand
                    :loading="!productsAndRiders"
                    :ref="eachPerson.id"
                  >
                    <template v-slot:headers="props">
                      <tr>
                        <th
                          role="columnheader"
                          scope="col"
                          :width="header.width"
                          aria-label="Not sorted."
                          aria-sort="none"
                          class="column text-xs-left"
                          v-for="(header, index) of props.headers"
                          :key="index"
                        >
                          <v-layout align-start justify-start>
                            <v-tooltip
                              top
                              dark
                              :color="mainColor"
                              v-if="header.text != 'Plan Description'"
                            >
                              <template v-slot:activator="{ on }">
                                <span v-on="on">{{ header.text }}</span>
                              </template>
                              <span>{{ header.value }}</span>
                            </v-tooltip>
                            <span v-if="header.text == 'Plan Description'">{{
                              header.text
                            }}</span>
                          </v-layout>
                        </th>
                      </tr>
                    </template>

                    <v-progress-linear
                      v-slot:progress
                      color="blue"
                      :indeterminate="true"
                    ></v-progress-linear>
                    <template
                      slot="items"
                      slot-scope="props"
                      :sub="item.name"
                      v-if="props.item.rider.id == undefined"
                    >
                      <tr
                        @click.stop="props.expanded = props.item.expandMe"
                        v-open="props"
                      >
                        <td class="text-xs-left">
                          <template v-if="props.item.rider.name === undefined">
                            <template
                              v-if="
                                props.item.product.description === undefined
                              "
                            >
                              <p class="productFont">
                                {{ props.item.product.name }}
                              </p>
                            </template>
                            <template v-else>
                              <v-tooltip bottom max-width="300">
                                <template v-slot:activator="{ on }">
                                  <span v-on="on" class="productFont">
                                    {{ props.item.product.name }}
                                    &nbsp;&nbsp;
                                    <v-icon>info</v-icon>
                                  </span>
                                </template>
                                <span>{{
                                  props.item.product.description
                                }}</span>
                              </v-tooltip>
                            </template>
                          </template>
                        </td>
                        <td
                          v-for="(person, index) of props.item.people"
                          :key="index"
                        >
                          <template
                            v-if="
                              productExcludedForInsured(
                                person,
                                props.item.product,
                                props.item.rider
                              )
                            "
                          >
                            <v-tooltip bottom max-width="300">
                              <template v-slot:activator="{ on }">
                                <span v-on="on">
                                  <v-layout justify-start align-content-start
                                    >N/A</v-layout
                                  >
                                </span>
                              </template>
                              <span>Product excluded by age requirements.</span>
                            </v-tooltip>
                          </template>
                          <template v-else>
                            <template
                              v-if="
                                disableCheckbox(
                                  person,
                                  props.item.product.productId,
                                  props.item.product.planCodeId,
                                  props.item.rider
                                ) && !productIsSelected(person, props.item)
                              "
                            >
                              <v-tooltip bottom max-width="300">
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">
                                    <v-checkbox
                                      multiple
                                      v-model="selections"
                                      @change="watchSelections"
                                      :value="
                                        props.item.product.productId.toString() +
                                        '|' +
                                        props.item.product.planCodeId.toString() +
                                        '|' +
                                        person.id +
                                        '|' +
                                        (props.item.rider != undefined &&
                                        props.item.rider.id != undefined
                                          ? props.item.rider.id.toString()
                                          : '')
                                      "
                                      :color="mainColor"
                                      disabled
                                    ></v-checkbox>
                                  </span>
                                </template>
                                <span
                                  >Product excluded by other selections.</span
                                >
                              </v-tooltip>
                            </template>
                            <template v-else>
                              <v-checkbox
                                multiple
                                v-model="selections"
                                @change="watchSelections"
                                :value="
                                  props.item.product.productId.toString() +
                                  '|' +
                                  props.item.product.planCodeId.toString() +
                                  '|' +
                                  person.id +
                                  '|'
                                "
                                :color="mainColor"
                                :disabled="
                                  disableCheckbox(
                                    person,
                                    props.item.product.productId,
                                    props.item.product.planCodeId,
                                    props.item.rider
                                  )
                                "
                                :v-on="(props.expanded = props.item.expandMe)"
                                style="
                                  transition: none !important;
                                  -webkit-transition: none !important;
                                "
                              ></v-checkbox>
                            </template>
                          </template>
                        </td>
                      </tr>
                    </template>

                    <template slot="expand" slot-scope="props">
                      <v-data-table
                        :class="
                          $vuetify.breakpoint.xs
                            ? 'riderTableXs text-wrap'
                            : 'riderTableSm text-wrap'
                        "
                        :headers="props.item.filteredHeadersForRiders"
                        :items="props.item.riders"
                        hide-actions
                        item-key="index"
                        expand
                        :loading="false"
                        v-if="
                          props.item.riders.length > 0 &&
                          productIsSelected(eachPerson, props.item)
                        "
                      >
                        <template
                          slot="items"
                          slot-scope="props"
                          :sub="item.name"
                          width="100%"
                        >
                          <tr>
                            <!-- v-for="(props.item,index) of props.item.riders" :key="index"> -->
                            <td
                              class="text-xs-left"
                              :style="
                                $vuetify.breakpoint.xs ? 'max-width:100px;' : ''
                              "
                            >
                              <v-tooltip bottom max-width="300">
                                <template v-slot:activator="{ on }">
                                  <span v-on="on" class="riderFontSm text-wrap">
                                    {{ props.item.rider.name }}
                                    &nbsp;&nbsp;
                                    <v-icon>info</v-icon>
                                  </span>
                                </template>
                                <span>{{ props.item.rider.description }}</span>
                              </v-tooltip>
                            </td>
                            <td
                              v-for="(person, index) of props.item.people"
                              :key="index"
                              style="
                                margin: 0px !important;
                                padding-right: 0px !important;
                              "
                            >
                              <template
                                v-if="
                                  (props.item.rider &&
                                    props.item.rider.type === 'CR' &&
                                    childEligible(
                                      person,
                                      props.item.rider,
                                      props.item.product
                                    ) == 'true') ||
                                  (props.item.product &&
                                    props.item.product.type === 'ADP' &&
                                    childEligibleByAge(
                                      person,
                                      props.item.product
                                    ))
                                "
                              >
                                <v-layout justify-start align-content-start
                                  >N/A</v-layout
                                >
                                <!-- <v-tooltip bottom max-width="300">
                                  <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                      <v-layout
                                        justify-start
                                        align-content-start
                                      >
                                        <v-icon :color="mainColor"
                                          >add_circle</v-icon
                                        >
                                      </v-layout>
                                    </span>
                                  </template>
                                  <span>Child eligible based on age to be covered by parent's child rider, if selected</span>
                                </v-tooltip> -->
                              </template>
                              <template
                                v-else-if="
                                  props.item.rider &&
                                  props.item.rider.type === 'CR' &&
                                  childEligible(
                                    person,
                                    props.item.rider,
                                    props.item.product
                                  ) == 'NA'
                                "
                              >
                                <v-layout justify-start align-content-start
                                  >N/A</v-layout
                                >

                                <!-- <v-tooltip bottom max-width="300">
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">
                            <v-layout justify-start align-content-start
                              >N/A</v-layout
                            >
                              </span>
                                </template>
                                <span
                                  >Not applicable based on parent selection or age.</span
                                >
                              </v-tooltip> -->
                              </template>
                              <template
                                v-else-if="
                                  (props.item.rider &&
                                    props.item.rider.type === 'CR' &&
                                    person.type.toLowerCase() === 'child') ||
                                  (props.item.product &&
                                    props.item.product.type === 'ADP' &&
                                    person.type.toLowerCase() === 'child')
                                "
                              >
                                <v-layout justify-start align-content-start
                                  >N/A</v-layout
                                >

                                <!-- <v-tooltip bottom max-width="300">
                                  <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                      <v-layout
                                        justify-start
                                        align-content-start
                                      >
                                        <v-icon :color="mainColor"
                                          >remove_circle</v-icon
                                        >
                                      </v-layout>
                                    </span>
                                  </template>
                                  <span>Child not eligible based on age to be covered by parent's child rider</span>
                                </v-tooltip> -->
                              </template>
                              <template
                                v-else-if="
                                  productExcludedForInsured(
                                    person,
                                    props.item.product,
                                    props.item.rider
                                  ) ||
                                  excludeRidersBasedOnNAProducts(
                                    person,
                                    props.item.rider
                                  )
                                "
                              >
                                <v-layout justify-start align-content-start
                                  >N/A</v-layout
                                >
                                <!-- <v-tooltip bottom max-width="300">
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">
                            <v-layout justify-start align-content-start
                              >N/A</v-layout
                            >
                              </span>
                                </template>
                                <span
                                  >Rider excluded by age requirements.</span
                                >
                              </v-tooltip> -->
                              </template>
                              <template v-else>
                                <template
                                  v-if="
                                    disableCheckbox(
                                      person,
                                      props.item.product.productId,
                                      props.item.product.planCodeId,
                                      props.item.rider
                                    ) && !productIsSelected(person, props.item)
                                  "
                                >
                                  <v-tooltip bottom max-width="300">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-checkbox
                                          multiple
                                          v-model="selections"
                                          @change="watchSelections"
                                          :value="
                                            props.item.product.productId.toString() +
                                            '|' +
                                            props.item.product.planCodeId.toString() +
                                            '|' +
                                            person.id +
                                            '|' +
                                            (props.item.rider != undefined &&
                                            props.item.rider.id != undefined
                                              ? props.item.rider.id.toString()
                                              : '')
                                          "
                                          :color="mainColor"
                                          disabled
                                        ></v-checkbox>
                                      </span>
                                    </template>
                                    <span>
                                      <template
                                        v-if="
                                          props.item.rider &&
                                          props.item.rider.name
                                        "
                                      >
                                        <template
                                          v-if="
                                            relatedProductSelectedForPerson(
                                              props.item.rider,
                                              person
                                            )
                                          "
                                          >Rider excluded by other
                                          selections.</template
                                        >
                                        <template v-else
                                          >Please select product to check rider
                                          availability.</template
                                        >
                                      </template>
                                      <template v-else
                                        >Product excluded by other
                                        selections.</template
                                      >
                                    </span>
                                  </v-tooltip>
                                </template>

                                <template
                                  v-else-if="
                                    disableCheckbox(
                                      person,
                                      props.item.product.productId,
                                      props.item.product.planCodeId,
                                      props.item.rider
                                    )
                                  "
                                >
                                  <v-tooltip bottom max-width="300">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-checkbox
                                          multiple
                                          v-model="selections"
                                          @change="watchSelections"
                                          :value="
                                            props.item.product.productId.toString() +
                                            '|' +
                                            props.item.product.planCodeId.toString() +
                                            '|' +
                                            person.id +
                                            '|' +
                                            (props.item.rider != undefined &&
                                            props.item.rider.id != undefined
                                              ? props.item.rider.id.toString()
                                              : '')
                                          "
                                          :color="mainColor"
                                          disabled
                                        ></v-checkbox>
                                      </span>
                                    </template>
                                    <span>Rider Automatically Included</span>
                                  </v-tooltip>
                                </template>

                                <template v-else>
                                  <v-checkbox
                                    multiple
                                    v-model="selections"
                                    @change="watchSelections"
                                    :value="
                                      props.item.product.productId.toString() +
                                      '|' +
                                      props.item.product.planCodeId.toString() +
                                      '|' +
                                      person.id +
                                      '|' +
                                      (props.item.rider != undefined &&
                                      props.item.rider.id != undefined
                                        ? props.item.rider.id.toString()
                                        : '')
                                    "
                                    :color="mainColor"
                                    :disabled="
                                      disableCheckbox(
                                        person,
                                        props.item.product.productId,
                                        props.item.product.planCodeId,
                                        props.item.rider
                                      )
                                    "
                                  ></v-checkbox>
                                </template>
                              </template>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </template>
                  </v-data-table>

                  <br />
                  <br />
                </v-flex>
              </v-layout>
              <v-layout justify-center align-content-center>
                <template
                  v-if="
                    noProductAvailibility &&
                    !(rows === undefined || rows[0] === undefined)
                  "
                >
                  <p class="noProductsNotice">
                    At this time, the proposed insureds do not meet the age
                    requirements for product eligibility. Please contact your
                    organization's agent for more information.
                  </p>
                </template>
                <template v-else>
                  <br />
                  <br />
                  <p class="smallPrint">
                    Age requirements may affect the product availability
                    reflected above.
                    <br />*Rider automatically included with standard policy
                    (only) when age requirements are met.
                  </p>
                </template>
              </v-layout>

              <v-layout column>
                <v-btn :color="mainColor" dark @click="previousClick()"
                  >Back To Proposed Insureds</v-btn
                >

                <template v-if="noProductAvailibility">
                  <v-btn disabled>Continue</v-btn>
                </template>
                <template v-else>
                  <v-btn v-if="!selections || selections.length < 1" disabled
                    >Continue</v-btn
                  >
                  <v-btn
                    :color="mainColor"
                    dark
                    v-if="selections && selections.length >= 1"
                    @click="switchStep(3)"
                    >Continue</v-btn
                  >
                </template>
              </v-layout>
            </v-layout>
          </v-stepper-content>
          <!-- mdAndUp -->
          <v-stepper-content step="2" v-else>
            <v-layout justify-center align-content-center>
              <v-subheader style="color: #00558c"
                >Please select the coverage(s) you are interested in for each
                proposed insured:</v-subheader
              >
            </v-layout>

            <v-layout justify-center align-content-center>
              <v-flex xs12>
                <div style="display: block">
                  <v-data-table
                    class="fb-table-elem"
                    :headers="headers"
                    :items="productRows"
                    hide-actions
                    item-key="index"
                    expand
                    :loading="!productsAndRiders"
                    ref="productTable"
                  >
                    <template v-slot:headers="props">
                      <tr>
                        <th
                          role="columnheader"
                          scope="col"
                          :width="
                            header.text != 'Product Offering' ? '200' : '350'
                          "
                          aria-label="Product Offering: Not sorted."
                          aria-sort="none"
                          class="column text-xs-left"
                          v-for="(header, index) of props.headers"
                          :key="index"
                        >
                          <v-layout align-start justify-start>
                            <v-tooltip
                              top
                              dark
                              :color="mainColor"
                              v-if="header.text != 'Product Offering'"
                            >
                              <template v-slot:activator="{ on }">
                                <span v-on="on">{{ header.text }}</span>
                              </template>
                              <span>{{ header.value }}</span>
                            </v-tooltip>
                            <span v-if="header.text == 'Product Offering'">{{
                              header.text
                            }}</span>
                          </v-layout>
                        </th>
                      </tr>
                    </template>

                    <v-progress-linear
                      v-slot:progress
                      color="blue"
                      :indeterminate="true"
                    ></v-progress-linear>
                    <template
                      slot="items"
                      slot-scope="props"
                      :sub="item.name"
                      v-if="props.item.rider.id == undefined"
                    >
                      <tr
                        @click.stop="props.expanded = props.item.expandMe"
                        v-open="props"
                        ref="productTableRow"
                      >
                        <td
                          class="text-xs-left"
                          style="min-width: 350; max-width: 350; display: block"
                        >
                          <template v-if="props.item.rider.name === undefined">
                            <template
                              v-if="
                                props.item.product.description === undefined
                              "
                            >
                              <p class="productFont">
                                {{ props.item.product.name }}
                              </p>
                            </template>
                            <template v-else>
                              <v-tooltip bottom max-width="300">
                                <template v-slot:activator="{ on }">
                                  <span v-on="on" class="productFont">
                                    {{ props.item.product.name }}
                                    &nbsp;&nbsp;
                                    <v-icon>info</v-icon>
                                  </span>
                                </template>
                                <span>{{
                                  props.item.product.description
                                }}</span>
                              </v-tooltip>
                            </template>
                          </template>
                        </td>
                        <td
                          v-for="(person, index) of props.item.people"
                          :key="index"
                          style="min-width: 200px; max-width: 200px"
                        >
                          <template
                            v-if="
                              productExcludedForInsured(
                                person,
                                props.item.product,
                                props.item.rider
                              )
                            "
                          >
                            <v-tooltip bottom max-width="300">
                              <template v-slot:activator="{ on }">
                                <span v-on="on">
                                  <v-layout justify-start align-content-start
                                    >N/A</v-layout
                                  >
                                </span>
                              </template>
                              <span>Product excluded by age requirements.</span>
                            </v-tooltip>
                          </template>
                          <template v-else>
                            <template
                              v-if="
                                disableCheckbox(
                                  person,
                                  props.item.product.productId,
                                  props.item.product.planCodeId,
                                  props.item.rider
                                ) && !productIsSelected(person, props.item)
                              "
                            >
                              <v-tooltip bottom max-width="300">
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">
                                    <v-checkbox
                                      multiple
                                      v-model="selections"
                                      @change="watchSelections"
                                      :value="
                                        props.item.product.productId.toString() +
                                        '|' +
                                        props.item.product.planCodeId.toString() +
                                        '|' +
                                        person.id +
                                        '|' +
                                        (props.item.rider != undefined &&
                                        props.item.rider.id != undefined
                                          ? props.item.rider.id.toString()
                                          : '')
                                      "
                                      :color="mainColor"
                                      disabled
                                    ></v-checkbox>
                                  </span>
                                </template>
                                <span
                                  >Product excluded by other selections.</span
                                >
                              </v-tooltip>
                            </template>
                            <template v-else>
                              <v-checkbox
                                multiple
                                v-model="selections"
                                @change="watchSelections"
                                :value="
                                  props.item.product.productId.toString() +
                                  '|' +
                                  props.item.product.planCodeId.toString() +
                                  '|' +
                                  person.id +
                                  '|'
                                "
                                :color="mainColor"
                                :disabled="
                                  disableCheckbox(
                                    person,
                                    props.item.product.productId,
                                    props.item.product.planCodeId,
                                    props.item.rider
                                  )
                                "
                                :v-on="(props.expanded = props.item.expandMe)"
                              ></v-checkbox>
                            </template>
                          </template>
                        </td>
                      </tr>
                    </template>

                    <template slot="expand" slot-scope="props">
                      <v-data-table
                        class="riderTable"
                        :headers="props.item.headers"
                        :items="props.item.riders"
                        hide-actions
                        item-key="index"
                        :loading="false"
                        v-if="props.item.riders.length > 0"
                      >
                        <template
                          slot="items"
                          slot-scope="props"
                          :sub="item.name"
                        >
                          <tr>
                            <!-- v-for="(props.item,index) of props.item.riders" :key="index"> -->
                            <td
                              class="text-xs-left"
                              style="min-width: 350px; max-width: 350px"
                            >
                              <v-tooltip bottom max-width="300">
                                <template v-slot:activator="{ on }">
                                  <span v-on="on" class="riderFont">
                                    {{ props.item.rider.name }}
                                    &nbsp;&nbsp;
                                    <v-icon>info</v-icon>
                                  </span>
                                </template>
                                <span>{{ props.item.rider.description }}</span>
                              </v-tooltip>
                            </td>
                            <td
                              v-for="(person, index) of props.item.people"
                              :key="index"
                              style="
                                margin: 0px !important;
                                padding-right: 0px !important;
                                max-width: 200px;
                                min-width: 200px;
                              "
                            >
                              <template
                                v-if="
                                  (props.item.rider &&
                                    props.item.rider.type === 'CR' &&
                                    childEligible(
                                      person,
                                      props.item.rider,
                                      props.item.product
                                    ) == 'true') ||
                                  (props.item.product &&
                                    props.item.product.type === 'ADP' &&
                                    childEligibleByAge(
                                      person,
                                      props.item.product
                                    ))
                                "
                              >
                                <v-layout justify-start align-content-start
                                  >N/A</v-layout
                                >
                                <!-- <v-tooltip bottom max-width="300">
                                  <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                      <v-layout
                                        justify-start
                                        align-content-start
                                      >
                                        <v-icon :color="mainColor"
                                          >add_circle</v-icon
                                        >
                                      </v-layout>
                                    </span>
                                  </template>
                                  <span>Child eligible based on age to be covered by parent's child rider, if selected</span>
                                </v-tooltip> -->
                              </template>
                              <template
                                v-else-if="
                                  props.item.rider &&
                                  props.item.rider.type === 'CR' &&
                                  childEligible(
                                    person,
                                    props.item.rider,
                                    props.item.product
                                  ) == 'NA'
                                "
                              >
                                <v-layout justify-start align-content-start
                                  >N/A</v-layout
                                >
                                <!-- <v-tooltip bottom max-width="300">
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">
                            <v-layout justify-start align-content-start
                              >N/A</v-layout
                            >
                              </span>
                                </template>
                                <span
                                  >Not applicable based on parent selection or age.</span
                                >
                              </v-tooltip> -->
                              </template>
                              <template
                                v-else-if="
                                  (props.item.rider &&
                                    props.item.rider.type === 'CR' &&
                                    person.type.toLowerCase() === 'child') ||
                                  (props.item.product &&
                                    props.item.product.type === 'ADP' &&
                                    person.type.toLowerCase() === 'child')
                                "
                              >
                                <v-layout justify-start align-content-start
                                  >N/A</v-layout
                                >
                                <!-- <v-tooltip bottom max-width="300">
                                  <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                      <v-layout
                                        justify-start
                                        align-content-start
                                      >
                                        <v-icon :color="mainColor"
                                          >remove_circle</v-icon
                                        >
                                      </v-layout>
                                    </span>
                                  </template>
                                  <span>Child not eligible based on age to be covered by parent's child rider</span>
                                </v-tooltip> -->
                              </template>
                              <template
                                v-else-if="
                                  productExcludedForInsured(
                                    person,
                                    props.item.product,
                                    props.item.rider
                                  ) ||
                                  excludeRidersBasedOnNAProducts(
                                    person,
                                    props.item.rider
                                  )
                                "
                              >
                                <v-layout justify-start align-content-start
                                  >N/A</v-layout
                                >
                                <!-- <v-tooltip bottom max-width="300">
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">
                            <v-layout justify-start align-content-start
                              >N/A</v-layout
                            >
                              </span>
                                </template>
                                <span
                                  >Rider excluded by age requirements.</span
                                >
                              </v-tooltip> -->
                              </template>
                              <template v-else>
                                <template
                                  v-if="
                                    disableCheckbox(
                                      person,
                                      props.item.product.productId,
                                      props.item.product.planCodeId,
                                      props.item.rider
                                    ) && !productIsSelected(person, props.item)
                                  "
                                >
                                  <v-tooltip bottom max-width="300">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-checkbox
                                          multiple
                                          v-model="selections"
                                          @change="watchSelections"
                                          :value="
                                            props.item.product.productId.toString() +
                                            '|' +
                                            props.item.product.planCodeId.toString() +
                                            '|' +
                                            person.id +
                                            '|' +
                                            (props.item.rider != undefined &&
                                            props.item.rider.id != undefined
                                              ? props.item.rider.id.toString()
                                              : '')
                                          "
                                          :color="mainColor"
                                          disabled
                                        ></v-checkbox>
                                      </span>
                                    </template>
                                    <span>
                                      <template
                                        v-if="
                                          props.item.rider &&
                                          props.item.rider.name
                                        "
                                      >
                                        <template
                                          v-if="
                                            relatedProductSelectedForPerson(
                                              props.item.rider,
                                              person
                                            )
                                          "
                                          >Rider excluded by other
                                          selections.</template
                                        >
                                        <template v-else
                                          >Please select product to check rider
                                          availability.</template
                                        >
                                      </template>
                                      <template v-else
                                        >Product excluded by other
                                        selections.</template
                                      >
                                    </span>
                                  </v-tooltip>
                                </template>

                                <template
                                  v-else-if="
                                    disableCheckbox(
                                      person,
                                      props.item.product.productId,
                                      props.item.product.planCodeId,
                                      props.item.rider
                                    )
                                  "
                                >
                                  <v-tooltip bottom max-width="300">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-checkbox
                                          multiple
                                          v-model="selections"
                                          @change="watchSelections"
                                          :value="
                                            props.item.product.productId.toString() +
                                            '|' +
                                            props.item.product.planCodeId.toString() +
                                            '|' +
                                            person.id +
                                            '|' +
                                            (props.item.rider != undefined &&
                                            props.item.rider.id != undefined
                                              ? props.item.rider.id.toString()
                                              : '')
                                          "
                                          :color="mainColor"
                                          disabled
                                        ></v-checkbox>
                                      </span>
                                    </template>
                                    <span>Rider Automatically Included</span>
                                  </v-tooltip>
                                </template>

                                <template v-else>
                                  <v-checkbox
                                    multiple
                                    v-model="selections"
                                    @change="watchSelections"
                                    :value="
                                      props.item.product.productId.toString() +
                                      '|' +
                                      props.item.product.planCodeId.toString() +
                                      '|' +
                                      person.id +
                                      '|' +
                                      (props.item.rider != undefined &&
                                      props.item.rider.id != undefined
                                        ? props.item.rider.id.toString()
                                        : '')
                                    "
                                    :color="mainColor"
                                    :disabled="
                                      disableCheckbox(
                                        person,
                                        props.item.product.productId,
                                        props.item.product.planCodeId,
                                        props.item.rider
                                      )
                                    "
                                  ></v-checkbox>
                                </template>
                              </template>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </template>
                  </v-data-table>
                </div>

                <v-subheader>
                  <v-layout justify-center align-content-center column>
                    <template
                      v-if="
                        noProductAvailibility &&
                        !(rows === undefined || rows[0] === undefined)
                      "
                    >
                      <p class="noProductsNotice">
                        At this time, the proposed insureds do not meet the age
                        requirements for product eligibility. Please contact
                        your organization's agent for more information.
                      </p>
                    </template>
                    <template v-else>
                      <br />
                      <br />
                      <p class="smallPrint">
                        Age requirements may affect the product availability
                        reflected above.
                        <br />*Rider automatically included with standard policy
                        (only) when age requirements are met.
                      </p>
                    </template>
                  </v-layout>
                </v-subheader>
              </v-flex>
            </v-layout>
            <br />
            <br />

            <!-- end marker -->

            <v-layout justify-end align-content-end>
              <v-btn :color="mainColor" dark @click="previousClick()"
                >Back To Proposed Insureds</v-btn
              >

              <template v-if="noProductAvailibility">
                <v-btn disabled>Continue</v-btn>
              </template>
              <template v-else>
                <v-btn v-if="!selections || selections.length < 1" disabled
                  >Continue</v-btn
                >
                <v-btn
                  :color="mainColor"
                  dark
                  v-if="selections && selections.length >= 1"
                  @click="switchStep(3)"
                  >Continue</v-btn
                >
              </template>
            </v-layout>
          </v-stepper-content>

          <!-- Coverage Questions -->
          <v-stepper-content step="3">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12>
                  <template v-for="question in questions">
                    <div :key="question.question">
                      <template
                        v-if="question.question && question.answers.length > 0"
                      >
                        <p class="questionFont">{{ question.question }}</p>
                        <template v-if="omit(question)">
                          <v-layout
                            align-start
                            justify-start
                            align-content-start
                          >
                            <v-subheader>(Not Applicable)</v-subheader>
                          </v-layout>
                        </template>
                        <template v-else>
                          <v-radio-group
                            v-model="question.radioBtnAnswer"
                            row
                            :rules="radioBtnRules"
                            class="radioBtnPadding"
                            :readonly="omit(question)"
                            @change="checkDependencies(question)"
                          >
                            <v-radio
                              v-for="answer in question.answers"
                              :label="answer"
                              :value="answer"
                              :key="answer"
                              :color="mainColor"
                            ></v-radio>
                          </v-radio-group>
                        </template>

                        <v-card-text>{{ question.smallPrint }}</v-card-text>
                      </template>
                    </div>
                  </template>
                </v-flex>
              </v-layout>
            </v-form>

            <v-layout column v-if="$vuetify.breakpoint.smAndDown">
              <v-btn :color="mainColor" dark @click="previousClick()"
                >Back To Proposed Insureds</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(2)"
                >Previous</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(4)"
                >Continue</v-btn
              >
            </v-layout>

            <v-layout justify-end align-content-end v-else>
              <v-btn :color="mainColor" dark @click="previousClick()"
                >Back To Proposed Insureds</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(2)"
                >Previous</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(4)"
                >Continue</v-btn
              >
            </v-layout>
          </v-stepper-content>

          <!-- Rate Calculator -->
          <!-- smAndDown -->
          <v-stepper-content step="4" v-if="$vuetify.breakpoint.smAndDown">
            <br />
            <br />
            <v-flex xs11>
              <label for="budget"
                >How much are you willing to spend weekly?</label
              >
              <br />

              <br />
              <v-slider
                id="budget"
                v-model="budget"
                prepend-icon="attach_money"
                thumb-label="always"
                :thumb-size="thumbSize"
                min="5"
                max="50"
                step="5"
                always-dirty
                ref="budgetSlider"
                :color="mainColor"
                v-on:change="calculateRemaining()"
              ></v-slider>
            </v-flex>
            <label for="remaining">Remaining to Spend:</label>
            <v-flex xs11>
              <v-text-field
                v-model="remaining"
                id="remaining"
                prefix="$"
                type="Number"
                readonly
                :error="isNegative"
              ></v-text-field>
            </v-flex>

            <br />
            <br />
            <v-layout justify-center align-content-center>
              <v-flex xs11>
                <v-data-table
                  hide-actions
                  :headers="rateHeadersSm"
                  :items="rateRows"
                  class="myTable"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center">
                      <br />
                      <br />
                      {{ props.item.personType }}:&nbsp;
                      <strong>{{ props.item.name }}</strong>
                      <br />
                      <template v-if="props.item.rider">
                        <v-tooltip bottom max-width="300">
                          <template v-slot:activator="{ on }">
                            <span v-on="on" class="riderFontSm">
                              Rider:&nbsp;
                              {{ props.item.rider.name }}
                              &nbsp;&nbsp;
                              <v-icon>info</v-icon>
                            </span>
                          </template>
                          <span>{{ props.item.rider.description }}</span>
                        </v-tooltip>
                      </template>
                      <template v-else>
                        Plan Description:&nbsp;
                        <template
                          v-if="props.item.product.description === undefined"
                        >
                          <span class="productFont">{{
                            props.item.description
                          }}</span>
                        </template>
                        <template v-else>
                          <v-tooltip bottom max-width="300">
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="productFont">
                                {{ props.item.description }}
                                &nbsp;&nbsp;
                                <v-icon>info</v-icon>
                              </span>
                            </template>
                            <span>{{ props.item.product.description }}</span>
                          </v-tooltip>
                        </template>
                      </template>
                      <template v-if="!props.item.rider">
                        <template
                          v-if="props.item.cancer != undefined"
                        ></template>
                        <template
                          v-else-if="props.item.product.specialFaceAmount"
                        >
                          <br />Estimated Face Amount:&nbsp;
                          <p class="faceAmount">
                            {{ props.item.product.specialFaceAmount }}
                            <span
                              v-if="props.item.product.specialFaceAmountLineTwo"
                            >
                              <br />
                              {{ props.item.product.specialFaceAmountLineTwo }}
                            </span>
                          </p>
                        </template>
                        <template v-else>
                          <br />Estimated Face Amount:&nbsp;
                          <p class="faceAmount">
                            ${{ faceAmount(props.item, props.index) | money }}
                          </p>
                        </template>
                      </template>
                      <template
                        v-else-if="faceAmount(props.item, props.index) > 0"
                      >
                        <br />Estimated Face Amount:&nbsp;
                        <p class="faceAmount">
                          ${{ faceAmount(props.item, props.index) | money }}
                          <span v-if="props.item.rider.additional">{{
                            props.item.rider.additional
                          }}</span>
                        </p>
                      </template>
                      <br />
                      <br />

                      <template v-if="!props.item.rider">
                        Weekly Premium Amount:
                        <br />
                        <br />
                        <template v-if="props.item.cancer != undefined">
                          <p>
                            <span>{{ props.item.cancer }}</span>
                          </p>
                        </template>
                        <template
                          v-else-if="
                            props.item.product.specialPremium != undefined
                          "
                        >
                          <p>
                            <v-icon>attach_money</v-icon>
                            <span class="weeklyPremium">{{
                              props.item.product.specialPremium | money
                            }}</span>
                            <span v-if="props.item.product.specialPremiumNote"
                              >&nbsp;{{
                                props.item.product.specialPremiumNote
                              }}</span
                            >
                          </p>
                        </template>
                        <template v-else>
                          <v-slider
                            v-model="premiumIndexes[props.index]"
                            prepend-icon="attach_money"
                            thumb-label="always"
                            min="0"
                            :max="
                              props.item.premiumAmounts === undefined
                                ? 0
                                : props.item.premiumAmounts.length - 1
                            "
                            always-dirty
                            :thumb-size="thumbSize"
                            :loading="
                              props.item.premiumAmounts === undefined
                                ? 'green'
                                : false
                            "
                            :color="mainColor"
                            v-on:change="calculateRemaining()"
                          >
                            <template v-slot:thumb-label="selected">
                              <span>{{
                                premiumAmount(props.item, selected.value)
                                  | money
                              }}</span>
                            </template>
                          </v-slider>
                        </template>
                      </template>

                      <template
                        v-else-if="
                          props.item.rider.coverages &&
                          props.item.rider.coverages.length == 1
                        "
                      >
                        <span
                          v-if="
                            props.item.rider.coverages[0].PremiumPerWeek > 0
                          "
                        >
                          Weekly Premium Amount:
                          <br />
                          <br />
                          <v-icon>attach_money</v-icon>
                          <span class="weeklyPremium">{{
                            props.item.rider.coverages[0].PremiumPerWeek | money
                          }}</span>
                        </span>
                        <span v-else-if="props.item.rider.included">
                          Weekly Premium Amount:&nbsp;
                          <br />
                          <br />Included
                        </span>
                        <span v-else>
                          <v-slider
                            v-model="premiumIndexes[props.index]"
                            prepend-icon="attach_money"
                            thumb-label="always"
                            :min="0"
                            :max="
                              (
                                nonDFRTotalPremiums() / parseFloat(DFRStep) -
                                DFRMin / parseFloat(DFRStep)
                              ).toString()
                            "
                            :loading="
                              nonDFRTotalPremiums() === 0 ? 'green' : false
                            "
                            always-dirty
                            :thumb-size="thumbSize"
                            :color="mainColor"
                            v-on:change="calculateRemaining()"
                          >
                            <template v-slot:thumb-label="selected">
                              <span>{{
                                DFRPremiumAmount(
                                  selected.value,
                                  parseFloat(DFRMin),
                                  parseFloat(DFRStep)
                                ) | money
                              }}</span>
                            </template>
                          </v-slider>
                        </span>
                      </template>

                      <template
                        v-else-if="
                          props.item.rider.coverages &&
                          props.item.rider.coverages.length > 1
                        "
                      >
                        Weekly Premium Amount:
                        <br />
                        <br />
                        <v-slider
                          v-model="premiumIndexes[props.index]"
                          prepend-icon="attach_money"
                          thumb-label="always"
                          min="0"
                          :max="props.item.rider.coverages.length - 1"
                          always-dirty
                          :thumb-size="thumbSize"
                          :loading="
                            props.item.rider.coverages === undefined
                              ? 'green'
                              : false
                          "
                          :color="mainColor"
                          v-on:change="calculateRemaining()"
                        >
                          <template v-slot:thumb-label="selected">
                            <span>{{
                              premiumAmount(props.item, selected.value) | money
                            }}</span>
                          </template>
                        </v-slider>
                      </template>
                      <br />
                      <br />
                    </td>
                  </template>
                </v-data-table>
                <v-card-text class="smallPrint">
                  <v-layout justify-center align-content-center>
                    The minimum face amount that will be issued is $1,000.
                    <br />Face amounts reflected above are an estimate only. The
                    actual face amounts may vary from amounts shown.
                  </v-layout>
                  <p>
                    *Rider automatically included with standard policy (only)
                    when age requirements are met.
                  </p>
                </v-card-text>

                <v-form ref="payPeriodsForm" v-model="valid" lazy-validation>
                  <br />
                  <br />
                  <span style="color: #00558c"
                    >To help us calculate your estimated salary deduction,
                    please select your number of pay periods per year:</span
                  >
                  <v-radio-group
                    v-model="payPeriodsRadio"
                    label
                    :rules="payPeriodsRadioRule"
                  >
                    <v-radio label="24" value="24" :color="mainColor"></v-radio>
                    <v-radio label="26" value="26" :color="mainColor"></v-radio>
                    <v-radio label="52" value="52" :color="mainColor"></v-radio>
                    <v-radio
                      label="Other"
                      value="other"
                      :color="mainColor"
                    ></v-radio>
                  </v-radio-group>
                  <v-text-field
                    v-model="payPeriodsOther"
                    :disabled="!(payPeriodsRadio === 'other')"
                    maxlength="2"
                    @keypress="isDigitKeypress($event)"
                    :error-messages="otherPayPeriodRules"
                  ></v-text-field>
                </v-form>
              </v-flex>
            </v-layout>
            <br />
            <br />
            <v-layout column>
              <v-btn :color="mainColor" dark @click="previousClick()"
                >Back To Proposed Insureds</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(3)"
                >Previous</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(5)"
                >Continue</v-btn
              >
            </v-layout>
          </v-stepper-content>
          <!-- mdAndUp -->
          <v-stepper-content step="4" v-else>
            <br />
            <br />

            <v-layout align-content-center justify-center row wrap>
              <v-flex xs10>
                <v-layout align-content-center justify-center row wrap>
                  <v-flex xs7>
                    <label for="budget"
                      >How much are you willing to spend weekly?</label
                    >
                    <v-slider
                      id="budget"
                      v-model="budget"
                      prepend-icon="attach_money"
                      thumb-label="always"
                      :thumb-size="thumbSize"
                      min="5"
                      max="50"
                      step="5"
                      always-dirty
                      ref="budgetSlider"
                      :color="mainColor"
                      v-on:change="calculateRemaining()"
                    ></v-slider>
                  </v-flex>
                  <v-spacer></v-spacer>

                  <v-flex xs4>
                    <v-text-field
                      v-model="remaining"
                      id="remaining"
                      prefix="$"
                      type="Number"
                      readonly
                      :error="isNegative"
                    >
                      <template v-slot:label>
                        <p class="remainingToSpend">Remaining to Spend:</p>
                      </template>
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <br />
            <br />
            <v-layout justify-center align-content-center>
              <v-flex xs11>
                <v-data-table
                  hide-actions
                  :headers="rateHeaders"
                  :items="rateRows"
                  class="myTable"
                  :loading="!this.ratesLoaded"
                >
                  <v-progress-linear
                    v-slot:progress
                    color="blue"
                    :indeterminate="true"
                  ></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center">
                      <p>
                        <template
                          v-if="
                            !props.item.rider && props.item.displayName != ''
                          "
                          >{{ props.item.displayName }}&nbsp;({{
                            props.item.personType
                          }})</template
                        >
                      </p>
                    </td>
                    <td class="text-xs-left">
                      <template v-if="!props.item.rider">
                        <template
                          v-if="props.item.product.description === undefined"
                        >
                          <p class="productFont">
                            {{ props.item.description }}
                          </p>
                        </template>
                        <template v-else>
                          <v-tooltip bottom max-width="300">
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="productFont">
                                {{ props.item.product.name }}
                                &nbsp;&nbsp;
                                <v-icon>info</v-icon>
                              </span>
                            </template>
                            <span>{{ props.item.product.description }}</span>
                          </v-tooltip>
                        </template>
                      </template>
                      <template v-else>
                        <v-tooltip bottom max-width="300">
                          <template v-slot:activator="{ on }">
                            <span v-on="on" class="riderFont">
                              {{ props.item.description }} &nbsp;&nbsp;
                              <v-icon>info</v-icon>
                            </span>
                          </template>
                          <span>{{ props.item.rider.description }}</span>
                        </v-tooltip>
                      </template>
                    </td>
                    <td class="text-xs-center">
                      <template v-if="!props.item.rider">
                        <template
                          v-if="props.item.cancer != undefined"
                        ></template>
                        <template
                          v-else-if="props.item.product.specialFaceAmount"
                        >
                          <p class="faceAmount">
                            {{ props.item.product.specialFaceAmount }}
                            <span
                              v-if="props.item.product.specialFaceAmountLineTwo"
                            >
                              <br />
                              {{ props.item.product.specialFaceAmountLineTwo }}
                            </span>
                          </p>
                        </template>
                        <template v-else>
                          <p class="faceAmount">
                            ${{ faceAmount(props.item, props.index) | money }}
                          </p>
                        </template>
                      </template>
                      <template
                        v-else-if="faceAmount(props.item, props.index) > 0"
                      >
                        <p class="faceAmount">
                          ${{ faceAmount(props.item, props.index) | money }}
                          <span v-if="props.item.rider.additional">{{
                            props.item.rider.additional
                          }}</span>
                        </p>
                      </template>
                    </td>
                    <td class="text-xs-left">
                      <template v-if="!props.item.rider">
                        <template v-if="props.item.cancer != undefined">
                          <p>
                            <span>{{ props.item.cancer }}</span>
                          </p>
                        </template>

                        <template
                          v-else-if="
                            props.item.product.specialPremium != undefined
                          "
                        >
                          <p>
                            <v-icon>attach_money</v-icon>
                            <span class="weeklyPremium">{{
                              props.item.product.specialPremium | money
                            }}</span>
                            <span v-if="props.item.product.specialPremiumNote"
                              >&nbsp;{{
                                props.item.product.specialPremiumNote
                              }}</span
                            >
                          </p>
                        </template>
                        <template v-else>
                          <v-slider
                            v-model="premiumIndexes[props.index]"
                            prepend-icon="attach_money"
                            thumb-label="always"
                            min="0"
                            :max="
                              props.item.premiumAmounts === undefined
                                ? 0
                                : props.item.premiumAmounts.length - 1
                            "
                            always-dirty
                            :thumb-size="thumbSize"
                            :loading="
                              props.item.premiumAmounts === undefined
                                ? 'green'
                                : false
                            "
                            :color="mainColor"
                            v-on:change="calculateRemaining()"
                          >
                            <template v-slot:thumb-label="selected">
                              <span>{{
                                premiumAmount(props.item, selected.value)
                                  | money
                              }}</span>
                            </template>
                          </v-slider>
                        </template>
                      </template>

                      <template
                        v-else-if="
                          props.item.rider.coverages &&
                          props.item.rider.coverages.length == 1
                        "
                      >
                        <span
                          v-if="
                            props.item.rider.coverages[0].PremiumPerWeek > 0
                          "
                          class="weeklyPremium"
                        >
                          <v-icon>attach_money</v-icon>
                          {{
                            props.item.rider.coverages[0].PremiumPerWeek | money
                          }}
                        </span>
                        <span v-else-if="props.item.rider.included"
                          >Included</span
                        >

                        <span v-else>
                          <v-slider
                            v-model="premiumIndexes[props.index]"
                            prepend-icon="attach_money"
                            thumb-label="always"
                            :min="0"
                            :max="
                              (
                                nonDFRTotalPremiums() / parseFloat(DFRStep) -
                                DFRMin / parseFloat(DFRStep)
                              ).toString()
                            "
                            :loading="
                              nonDFRTotalPremiums() === 0 ? 'green' : false
                            "
                            always-dirty
                            :thumb-size="thumbSize"
                            :color="mainColor"
                            v-on:change="calculateRemaining()"
                          >
                            <template v-slot:thumb-label="selected">
                              <span>{{
                                DFRPremiumAmount(
                                  selected.value,
                                  parseFloat(DFRMin),
                                  parseFloat(DFRStep)
                                ) | money
                              }}</span>
                            </template>
                          </v-slider>
                        </span>
                      </template>

                      <template
                        v-else-if="
                          props.item.rider.coverages &&
                          props.item.rider.coverages.length == 2
                        "
                      >
                        <!-- 
                        radio marker-->

                        <v-radio-group
                          v-model="premiumIndexes[props.index]"
                          row
                          v-on:change="calculateRemaining()"
                        >
                          <v-radio
                            :label="
                              '$' +
                              $options.filters.money(
                                props.item.premiumAmounts[0].PremiumPerWeek
                              )
                            "
                            :value="0"
                            color="#00558c"
                          ></v-radio>
                          <v-radio
                            :label="
                              '$' +
                              $options.filters.money(
                                props.item.premiumAmounts[1].PremiumPerWeek
                              )
                            "
                            :value="1"
                            color="#00558c"
                          ></v-radio>
                        </v-radio-group>
                      </template>

                      <template
                        v-else-if="
                          props.item.rider.coverages &&
                          props.item.rider.coverages.length > 1
                        "
                      >
                        <v-slider
                          v-model="premiumIndexes[props.index]"
                          prepend-icon="attach_money"
                          thumb-label="always"
                          min="0"
                          :max="props.item.rider.coverages.length - 1"
                          always-dirty
                          :thumb-size="thumbSize"
                          :loading="
                            props.item.rider.coverages === undefined
                              ? 'green'
                              : false
                          "
                          :color="mainColor"
                          v-on:change="calculateRemaining()"
                        >
                          <template v-slot:thumb-label="selected">
                            <span>{{
                              premiumAmount(props.item, selected.value) | money
                            }}</span>
                          </template>
                        </v-slider>
                      </template>
                    </td>
                    <td></td>
                  </template>
                </v-data-table>
                <v-card-text class="smallPrint">
                  <v-layout justify-center align-content-center>
                    The minimum face amount that will be issued is $1,000.
                    <br />Face amounts reflected above are an estimate only. The
                    actual face amounts may vary from amounts shown.
                  </v-layout>
                  <p>
                    *Rider automatically included with standard policy (only)
                    when age requirements are met.
                  </p>
                </v-card-text>
                <v-form ref="payPeriodsForm" v-model="valid" lazy-validation>
                  <br />
                  <br />
                  <span style="color: #00558c"
                    >To help us calculate your estimated salary deduction,
                    please select your number of pay periods per year:</span
                  >
                  <v-layout>
                    <v-layout row wrap justify-end>
                      <v-flex shrink>
                        <v-radio-group
                          v-model="payPeriodsRadio"
                          label
                          row
                          :rules="payPeriodsRadioRule"
                        >
                          <v-radio
                            label="24"
                            value="24"
                            :color="mainColor"
                          ></v-radio>
                          <v-radio
                            label="26"
                            value="26"
                            :color="mainColor"
                          ></v-radio>
                          <v-radio
                            label="52"
                            value="52"
                            :color="mainColor"
                          ></v-radio>
                          <v-radio
                            label="Other"
                            value="other"
                            :color="mainColor"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex shrink>
                        <v-text-field
                          v-model="payPeriodsOther"
                          :disabled="!(payPeriodsRadio === 'other')"
                          maxlength="2"
                          @keypress="isDigitKeypress($event)"
                          :error-messages="otherPayPeriodRules"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>

            <br />
            <br />

            <v-layout justify-end align-content-end>
              <v-btn :color="mainColor" dark @click="previousClick()"
                >Back To Proposed Insureds</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(3)"
                >Previous</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(5)"
                >Continue</v-btn
              >
            </v-layout>
          </v-stepper-content>

          <!-- Rate Summary -->
          <!-- smAndDown -->
          <v-stepper-content step="5" v-if="$vuetify.breakpoint.smAndDown">
            <br />
            <br />
            <v-layout justify-center align-content-center>
              <v-subheader style="color: #00558c"
                >Based on your selections, here is a summary of the coverage you
                are applying for.</v-subheader
              >
            </v-layout>
            <br />
            <br />

            <v-layout justify-center align-content-center>
              <v-flex xs11>
                <v-data-table
                  hide-actions
                  :headers="rateSummaryHeadersSm"
                  :items="rateSummaryRows"
                  class="myTable"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center">
                      <br />
                      <br />
                      {{ props.item.personType }} : {{ props.item.name }}
                      <!-- <br />Plan Description:
                      <strong>{{ props.item.description }}</strong>-->

                      <template v-if="props.item.rider">
                        <v-tooltip bottom max-width="300">
                          <template v-slot:activator="{ on }">
                            <span v-on="on" class="riderFont">
                              <br />
                              Rider:&nbsp;
                              {{ props.item.rider.name }}
                              &nbsp;&nbsp;
                              <v-icon>info</v-icon>
                            </span>
                          </template>
                          <span>{{ props.item.rider.description }}</span>
                        </v-tooltip>
                      </template>
                      <template v-else>
                        <br />Plan Description:&nbsp;
                        <!-- {{ props.item.description }} -->

                        <template
                          v-if="props.item.product.description === undefined"
                        >
                          <span class="productFont">{{
                            props.item.description
                          }}</span>
                        </template>
                        <template v-else>
                          <v-tooltip bottom max-width="300">
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="productFont">
                                {{ props.item.description }}
                                &nbsp;&nbsp;
                                <v-icon>info</v-icon>
                              </span>
                            </template>
                            <span>{{ props.item.product.description }}</span>
                          </v-tooltip>
                        </template>
                      </template>

                      <span v-if="props.item.cancer"></span>
                      <span
                        v-else-if="
                          props.item.product &&
                          props.item.product.specialFaceAmount
                        "
                      >
                        <br />Estimated Face Amount:
                        <strong>
                          <p>
                            {{ props.item.product.specialFaceAmount }}
                            <span
                              v-if="props.item.product.specialFaceAmountLineTwo"
                            >
                              <br />
                              {{ props.item.product.specialFaceAmountLineTwo }}
                            </span>
                          </p>
                        </strong>
                      </span>

                      <span v-else-if="props.item.faceAmt > 0">
                        <br />Estimated Face Amount:
                        <strong>${{ props.item.faceAmt | money }}</strong>

                        <br />
                      </span>

                      <span v-if="props.item.cancer != undefined">
                        <p>
                          <span>{{ props.item.cancer }}</span>
                        </p>
                      </span>
                      <span v-else-if="props.item.premium > 0">
                        <br />
                        <br />
                        <strong
                          >Weekly Premium Amount: ${{
                            props.item.premium | money
                          }}</strong
                        >
                        <span
                          v-if="props.item.rider && props.item.rider.additional"
                          >&nbsp;{{ props.item.rider.additional }}</span
                        >
                        <br />
                      </span>
                      <span
                        v-else-if="
                          props.item.rider && props.item.rider.included
                        "
                      >
                        <br />
                        <br />
                        <strong>Weekly Premium Amount: Included</strong>
                        <br />
                      </span>

                      <br />
                      <br />
                    </td>
                  </template>

                  <template v-slot:footer>
                    <td>
                      <v-layout align-content-center justify-center>
                        <strong
                          >Total Weekly Premium: ${{
                            premiumsSum | money
                          }}</strong
                        >
                      </v-layout>
                    </td>
                  </template>
                </v-data-table>
                <v-card-text class="smallPrint">
                  <v-layout justify-center align-content-center
                    >Face amounts reflected above are an estimate only. The
                    actual face amounts may vary from amounts shown.<br />
                    Per the terms of each applicable policy, issue date of
                    coverage will be based on the application and the payment of
                    the first premium.
                  </v-layout>
                  <p>
                    *Rider automatically included with standard policy (only)
                    when age requirements are met.
                  </p>
                </v-card-text>

                <v-card>
                  <v-card-text class="notice">
                    Based on your total weekly premium (${{
                      premiumsSum | money
                    }}), and the number of pay periods per year you supplied ({{
                      payPeriods
                    }}), your estimated deduction will be
                    <strong>${{ estimatedDeduction | money }}</strong
                    >&nbsp;per paycheck.
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

            <br />
            <br />
            <v-layout column>
              <v-btn :color="mainColor" dark @click="previousClick()"
                >Back To Proposed Insureds</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(4)"
                >Previous</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(6)"
                >Continue</v-btn
              >
            </v-layout>
          </v-stepper-content>
          <!-- mdAndUp -->
          <v-stepper-content step="5" v-else>
            <v-layout justify-center align-content-center>
              <v-subheader style="color: #00558c"
                >Based on your selections, here is a summary of the coverage you
                are applying for.</v-subheader
              >
            </v-layout>
            <br />
            <v-layout justify-center align-content-center>
              <v-flex xs11>
                <v-data-table
                  hide-actions
                  :headers="rateSummaryHeaders"
                  :items="rateSummaryRows"
                  class="myTable"
                >
                  <template slot="items" slot-scope="props">
                    <!-- <td class="text-xs-center">
                      <span v-if="!props.item.rider">{{ props.item.personType }}</span>
                    </td>-->
                    <td class="text-xs-center">
                      <span
                        v-if="!props.item.rider && props.item.displayName != ''"
                        >{{ props.item.displayName }}&nbsp;({{
                          props.item.personType
                        }})</span
                      >
                    </td>
                    <td class="text-xs-left">
                      <template v-if="props.item.rider">
                        <v-tooltip bottom max-width="300">
                          <template v-slot:activator="{ on }">
                            <span v-on="on" class="riderFont">
                              {{ props.item.description }}&nbsp;&nbsp;
                              <v-icon>info</v-icon>
                            </span>
                          </template>
                          <span>{{ props.item.rider.description }}</span>
                        </v-tooltip>
                      </template>
                      <template v-else>
                        <!-- <span class="productFont">{{ props.item.description }}</span>
                        -->

                        <template
                          v-if="props.item.product.description === undefined"
                        >
                          <p class="productFont">
                            {{ props.item.description }}
                          </p>
                        </template>
                        <template v-else>
                          <v-tooltip bottom max-width="300">
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="productFont">
                                {{ props.item.description }}
                                &nbsp;&nbsp;
                                <v-icon>info</v-icon>
                              </span>
                            </template>
                            <span>{{ props.item.product.description }}</span>
                          </v-tooltip>
                        </template>
                      </template>

                      <!-- <span v-if="props.item.rider" class="riderFont">{{ props.item.description }}</span>


                      <span v-else class="productFont">{{ props.item.description }}</span>-->
                    </td>
                    <td class="text-xs-center">
                      <span
                        v-if="
                          props.item.product &&
                          props.item.product.specialFaceAmount
                        "
                      >
                        {{ props.item.product.specialFaceAmount }}
                        <span
                          v-if="props.item.product.specialFaceAmountLineTwo"
                        >
                          <br />
                          {{ props.item.product.specialFaceAmountLineTwo }}
                        </span>
                      </span>
                      <span v-else-if="props.item.faceAmt > 0"
                        >${{ props.item.faceAmt | money }}</span
                      >
                      <span
                        v-if="props.item.rider && props.item.rider.additional"
                        >&nbsp;{{ props.item.rider.additional }}</span
                      >
                    </td>
                    <td class="text-xs-center">
                      <span v-if="props.item.cancer != undefined">
                        <p>
                          <span>{{ props.item.cancer }}</span>
                        </p>
                      </span>

                      <span
                        v-else-if="
                          props.item.product &&
                          props.item.product.specialPremium != undefined
                        "
                      >
                        ${{ props.item.product.specialPremium | money }}
                        <span v-if="props.item.product.specialPremiumNote"
                          >&nbsp;{{
                            props.item.product.specialPremiumNote
                          }}</span
                        >
                      </span>

                      <span v-else-if="props.item.premium > 0"
                        >${{ props.item.premium | money }}</span
                      >
                      <span
                        v-else-if="
                          props.item.rider && props.item.rider.included
                        "
                        >Included</span
                      >
                    </td>
                  </template>

                  <template v-slot:footer>
                    <td :colspan="2"></td>
                    <td>
                      <v-layout align-content-center justify-center>
                        <strong>Total Weekly Premium:</strong>
                      </v-layout>
                    </td>
                    <td>
                      <strong>${{ premiumsSum | money }}</strong>
                    </td>
                  </template>
                </v-data-table>
                <v-card-text class="smallPrint">
                  <v-layout justify-center align-content-center
                    >Face amounts reflected above are an estimate only. The
                    actual face amounts may vary from amounts shown.<br />
                    Per the terms of each applicable policy, issue date of
                    coverage will be based on the application and the payment of
                    the first premium.</v-layout
                  >

                  <p>
                    *Rider automatically included with standard policy (only)
                    when age requirements are met.
                  </p>
                </v-card-text>
                <v-card>
                  <v-card-text class="notice">
                    Based on your total weekly premium (${{
                      premiumsSum | money
                    }}), and the number of pay periods per year you supplied ({{
                      payPeriods
                    }}), your estimated deduction will be
                    <strong>${{ estimatedDeduction | money }}</strong
                    >&nbsp;per paycheck.
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

            <br />
            <br />
            <v-layout justify-end align-content-end>
              <v-btn :color="mainColor" dark @click="previousClick()"
                >Back To Proposed Insureds</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(4)"
                >Previous</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(6)"
                >Continue</v-btn
              >
            </v-layout>
          </v-stepper-content>

          <!-- Next Steps -->
          <!-- smAndDown -->
          <v-stepper-content step="6" v-if="$vuetify.breakpoint.smAndDown">
            <v-layout justify-center align-content-center column wrap>
              <br />
              <br />
              <v-subheader>
                <v-layout justify-center align-content-center>
                  <span style="color: #00558c"
                    >Based on your selected coverages, the following
                    individual(s) with a signature status of 'Required' will
                    need to sign the application.</span
                  >
                </v-layout>
              </v-subheader>
            </v-layout>
            <br />
            <br />
            <v-layout justify-center align-content-center>
              <v-flex xs11>
                <v-data-table
                  hide-actions
                  :headers="summaryHeadersSm"
                  :items="summaryRows"
                  class="myTable"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center">
                      <br />
                      <br />
                      {{ props.item.personType }} :
                      <strong>{{ props.item.name }}</strong>
                      <br />DOB:
                      <strong>{{ props.item.dob }}</strong>
                      <br />Gender:
                      <strong>{{ props.item.sex }}</strong>
                      <br />E-Mail:
                      <strong>{{ props.item.email }}</strong>
                      <br />
                      <br />Signature Status:
                      <strong>{{ props.item.sigReq }}</strong>
                      <br />
                      <br />
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <br />
            <br />

            <v-layout justify-center align-content-center row wrap>
              <p class="notice">
                Please ensure the following information and your selections to
                this point are accurate before continuing.
              </p>
            </v-layout>

            <br />
            {{ employee.name }}
            <br />
            {{ employee.street }}, {{ employee.city }}, {{ employee.state }}
            {{ employee.zip }}
            <br />
            home: {{ employee.homePhone | phone }} work:
            {{ employee.workPhone | phone }}
            <br />
            <br />

            <v-layout justify-center align-content-center row wrap>
              <p class="notice">
                You will be unable to change your selections or modify names,
                dates of birth, address or email addresses past this point.
              </p>
            </v-layout>
            <br />
            <br />
            <v-layout justify-center align-content-center row wrap>
              <span>
                To continue your application, click&nbsp;
                <strong>Continue to Form Completion</strong>
                &nbsp;to be redirected to DocuSign to complete and sign the
                relevant forms.
              </span>
            </v-layout>
            <br />
            <v-layout justify-center align-content-center row wrap>
              <span style="color: red">
                <i
                  >Important: You will be asked for a security code upon
                  redirection. Please enter the MMDD value of your birthdate.</i
                >
              </span>
            </v-layout>
            <br />

            <br />
            <v-layout column>
              <v-btn :color="mainColor" dark @click="previousClick()"
                >Back To Proposed Insureds</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(5)"
                >Previous</v-btn
              >

              <v-btn v-if="!agreement" disabled
                >Continue to Form Completion</v-btn
              >
              <v-btn
                :color="mainColor"
                dark
                v-if="agreement"
                @click="continueClick"
                >Continue to Form Completion</v-btn
              >
            </v-layout>
          </v-stepper-content>
          <!-- mdAndUp -->
          <v-stepper-content step="6" v-else>
            <v-layout justify-center align-content-center column wrap>
              <v-subheader>
                <v-layout justify-center align-content-center>
                  <span style="color: #00558c"
                    >Based on your selected coverages, the following
                    individual(s) with a signature status of 'Required' will
                    need to sign the application.</span
                  >
                </v-layout>
              </v-subheader>
            </v-layout>
            <br />
            <v-layout justify-center align-content-center>
              <v-flex xs11>
                <v-data-table
                  hide-actions
                  :headers="summaryHeaders"
                  :items="summaryRows"
                  class="myTable"
                >
                  <template slot="items" slot-scope="props">
                    <!-- <td class="text-xs-center">{{ props.item.personType }}</td> -->
                    <td class="text-xs-center">
                      {{ props.item.name }} &nbsp; ({{ props.item.personType }})
                    </td>
                    <td class="text-xs-center">{{ props.item.dob }}</td>
                    <td class="text-xs-center">{{ props.item.sex }}</td>
                    <td class="text-xs-center">{{ props.item.email }}</td>
                    <td class="text-xs-center">{{ props.item.sigReq }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <br />
            <br />

            <v-layout justify-center align-content-center row wrap>
              <p class="notice">
                Please ensure the following information and your selections to
                this point are accurate before continuing.
              </p>
            </v-layout>

            <br />
            {{ employee.name }}
            <br />
            {{ employee.street }}, {{ employee.city }}, {{ employee.state }}
            {{ employee.zip }}
            <br />
            home: {{ employee.homePhone | phone }} work:
            {{ employee.workPhone | phone }}
            <br />
            <br />

            <v-layout justify-center align-content-center row wrap>
              <p class="notice">
                You will be unable to change your selections or modify names,
                dates of birth, address or email addresses past this point.
              </p>
            </v-layout>
            <br />

            <v-layout justify-center align-content-center row wrap>
              <span>
                To continue your application, click&nbsp;
                <strong>Continue to Form Completion</strong>
                &nbsp;to be redirected to DocuSign to complete and sign the
                relevant forms.
              </span>
            </v-layout>
            <br />
            <v-layout justify-center align-content-center row wrap>
              <span style="color: red">
                <i
                  >Important: You will be asked for a security code upon
                  redirection. Please enter the MMDD value of your birthdate.</i
                >
              </span>
            </v-layout>
            <br />

            <br />
            <br />
            <v-layout justify-end align-content-end>
              <v-btn :color="mainColor" dark @click="previousClick()"
                >Back to Proposed Insureds</v-btn
              >
              <v-btn :color="mainColor" dark @click="switchStep(5)"
                >Previous</v-btn
              >

              <v-btn v-if="!agreement" disabled
                >Continue to Form Completion</v-btn
              >
              <v-btn
                :color="mainColor"
                dark
                v-if="agreement"
                @click="continueClick"
                >Continue to Form Completion</v-btn
              >
            </v-layout>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <v-dialog v-model="waitDialog" width="500">
      <v-card color="white">
        <v-card-title
          class="headline"
          primary-title
          :style="{ color: mainColor }"
        >
          <v-layout justify-center align-content-center>Please Wait</v-layout>
        </v-card-title>
        <v-card-text :style="{ color: mainColor }"
          >We're gathering the rate information for your product
          selections.</v-card-text
        >
        <br />
        <br />
      </v-card>
    </v-dialog>
    <v-dialog v-model="warningDialog" width="500">
      <v-card color="white">
        <v-toolbar :color="mainColor" dark>
          <span class="headline" primary-title style="color: white">
            <v-layout justify-start align-content-start>Continue?</v-layout>
          </span>
        </v-toolbar>
        <v-card-text>
          You have not made selections for one or more proposed insureds.
          <br />
          <br />Are you sure you want to continue?
        </v-card-text>
        <br />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="mainColor" @click="warningDialog = false" dark
            >Cancel</v-btn
          >
          <v-btn
            :color="mainColor"
            dark
            @click="
              warningDialog = false
              switchStepFromDialog()
            "
            >Continue</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <errorDialog :mainColor="mainColor" v-model="error"></errorDialog>
  </div>
</template>

<script>
import EventBus from '../event-bus'
import store from '../store'

import { AWS_HTTP } from '../http-common.js'
import { log } from '../http-common.js'
import logic from '../logic.js'

import axios from 'axios'
import plancodes from '../data/plan-codes.js'
import ridersFromFile from '../data/riders.js'

export default {
  name: 'EligibleProducts',
  props: { mainColor: String, entity: Object },
  components: {
    errorDialog: () => import(/* webpackPrefetch: true */ './error-dialog.vue'),
  },
  data: () => ({
    selectionInfoCache: [],
    error: false,
    errors: [],
    waitDialog: false,
    warningDialog: false,
    currentTabIndex: 2,
    ratesLoaded: false,
    productHeaderWidth: 300,
    noProductAvailibility: false,
    dialogNote: {},
    e1: 2, // the current tab index
    budget: 10, // the starting desired weekly premium
    remaining: 10,
    selections: [], // the product selections
    valid: true, // question validation
    radioBtnRules: [(v) => !!v || 'Please supply an answer.'], // rules for the question radio buttons
    payPeriodsRadioRule: [(v) => !!v || 'Please select an option.'], // rules for the pay periods radio buttons
    //errors: [], // for errors returned by the API calls
    questions: [], // health and replacement questions array
    omitQuestions: [], // for questions that should be omitted based on other questions' answers
    slider: 10, // the starting value for the desired weekly premium slider
    premiumIndexes: [], // the slider values
    ratesTable: [], // the array of rate arrays returned from the API
    agreement: true, // placeholder value for enabling the continue to form completion button that redirects to DocuSign
    payPeriodsRadio: store.state.payPeriodsRadio
      ? store.state.payPeriodsRadio
      : '26', // value of the pay periods radio buttons
    payPeriodsOther: '',
    riders: [],
    riderPremiums: [],
    DFRStep: '0.5',
    DFRMin: '5',
    initialize: true,
    productsAndRiders: false,
    thumbSize: '30',
    oldestCancerApplicant: {},
  }),
  directives: {
    open: {
      bind: function (el, binding) {
        binding.value.expanded = binding.value.item.expandMe
      },
    },
  },
  mounted() {
    try {
      this.payPeriodsRadio = store.state.payPeriodsRadio
        ? store.state.payPeriodsRadio
        : '26'

      this.payPeriodsOther = store.state.payPeriodsOther
        ? store.state.payPeriodsOther
        : ''

      this.$nextTick(() => {
        if (this.$store.state.productsPage) {
          // console.log(this.$store.state.productsPage)
          this.switchStep(this.$store.state.productsPage)
          // console.log(this.e1)
        }
      })

      this.selectionInfoCache = store.state.selectionsInfoCache

      // console.log(this.selectionInfoCache);

      for (let idx = 0; idx < this.selectionInfoCache.length; idx++) {
        for (let p of this.storedPersons) {
          if (this.selectionInfoCache[idx].pAndP.person.id == p.id) {
            let sel = JSON.parse(JSON.stringify(this.selectionInfoCache[idx]))
            sel.pAndP.person = JSON.parse(JSON.stringify(p))

            //  console.log(sel);

            this.selectionInfoCache.splice(idx, 1, sel)
          }
        }
      }

      // console.log(this.selectionInfoCache);
    } catch (e) {
      log(e.toString(), true, 'tmk-products-and-questions.vue mounted')
      this.error = true
      // console.log(e)
      this.errors.push(e)
    }
    EventBus.$on(
      'saveProducts',
      function () {
        try {
          this.$store.commit('setProductsPage', this.e1)
          store.commit('setPayPeriodsRadio', this.payPeriodsRadio)
          store.commit('setPaycheckDeductions', this.estimatedDeduction)
          store.commit('setPayPeriodsOther', this.payPeriodsOther)

          this.$store.commit('setselectionsInfoCache', this.selectionInfoCache)

          if (this.e1 == 2) {
            if (this.selections) {
              this.saveSelectionsToStore()
            }
          } else if (this.e1 == 3) {
            this.save()
          } else if (this.e1 === 4) {
            this.saveRates()
          }
        } catch (e) {
          log(e.toString(), true, 'tmk-products-and-questions.vue mounted')
          this.error = true
          // console.log(e)
          this.errors.push(e)
        }
      }.bind(this)
    )
  },
  beforeDestroy() {
    EventBus.$off('saveProducts')
  },
  created() {
    try {
      this.initialize = true
      this.productsAndRiders = false

      this.payPeriodsRadio = store.state.payPeriodsRadio
        ? store.state.payPeriodsRadio
        : '26'

      this.payPeriodsOther = store.state.payPeriodsOther
        ? store.state.payPeriodsOther
        : ''

      for (let i = 0; i < 100; i++) {
        this.premiumIndexes.push(0)
      }

      this.selections = []
      if (store.state.selections && store.state.selections.length > 0) {
        this.selections = store.state.selections
      }

      let promises = []

      //----------------------------------------------------------------------------------------------------

      let use_db = true

      if (use_db == undefined || use_db == false) {
        let planCodeList = plancodes.sort(function (a, b) {
          return a.displayOrder - b.displayOrder
        })

        store.commit('clearProducts')

        if (planCodeList && planCodeList.length > 0) {
          for (let planCode of planCodeList) {
            let editedPlanCodeId = planCode.PlanCode_ID

            editedPlanCodeId = editedPlanCodeId.replace('\ufeff', '')

            let planParts = editedPlanCodeId.split('_')
            let productId = 0

            if (planParts && planParts.length >= 2) {
              productId = planParts[1]
            }

            let product = {
              planCodeId: editedPlanCodeId,
              productId: productId,
              planNumber: planCode.PlanCodeNumber,
              name: planCode.PlancodeDescription,
              minAgeDays: planCode.MinAgeDays,
              maxAgeDays: planCode.MaxAgeDays,
              minAgeYears: planCode.MinAgeYears,
              maxAgeYears: planCode.MaxAgeYears,
              excludesProducts: planCode.excludesProducts,
              displayOrder: planCode.displayOrder,
              // noRates: planCode.noRates,
              // requirements: planCode.requirements,
              // eligibility: planCode.eligibility,
              // type: planCode.type,
              // specialPremium: planCode.specialPremium,
              // specialPremiumNote: planCode.specialPremiumNote,
              // specialFaceAmount: planCode.specialFaceAmount,
              // specialFaceAmountLineTwo: planCode.specialFaceAmountLineTwo,
              // description: planCode.Description
            }

            store.commit('addProduct', product)

            this.noProductAvailibility = this.checkForProductAvailibility()
          }
        }

        this.riders = ridersFromFile
        store.commit('clearRiders')

        for (let rider of this.riders) {
          store.commit('addRider', rider)
        }

        this.productsAndRiders = true
      } else {
        promises.push(
          AWS_HTTP.get('plancodes', {
            params: {},
          })
            .then((response) => {
              let responseData = response.data

              let planCodeList = responseData.sort(function (a, b) {
                return a.displayOrder - b.displayOrder
              })

              store.commit('clearProducts')

              if (planCodeList && planCodeList.length > 0) {
                for (let planCode of planCodeList) {
                  let editedPlanCodeId = planCode.PlanCode_ID_Id

                  editedPlanCodeId = editedPlanCodeId.replace('\ufeff', '')

                  let planParts = editedPlanCodeId.split('_')
                  let productId = 0

                  if (planParts && planParts.length >= 2) {
                    productId = planParts[1]
                  }

                  let product = {
                    planCodeId: editedPlanCodeId,
                    productId: productId,
                    planNumber: planCode.PlanCodeNumber,
                    name: planCode.PlanCodeDescription,
                    minAgeDays: planCode.MinAgeDays,
                    maxAgeDays: planCode.MaxAgeDays,
                    minAgeYears: planCode.MinAgeYears,
                    maxAgeYears: planCode.MaxAgeYears,
                    excludesProducts: planCode.excludesProducts,
                    displayOrder: planCode.displayOrder,
                    planCodeCrosswalk: planCode.planCodeCrosswalk,
                    // noRates: planCode.noRates,
                    // requirements: planCode.requirements,
                    // eligibility: planCode.eligibility,
                    // type: planCode.type
                  }

                  store.commit('addProduct', product)

                  this.noProductAvailibility =
                    this.checkForProductAvailibility()
                }
              }
            })
            .catch((e) => {
              // console.log(e)
              log(e.toString(), true, 'tmk-products-and-questions.vue created')
              this.errors.push(e)
              this.error = true
            })
        )

        promises.push(
          AWS_HTTP.get('riders', {
            params: {},
          })
            .then((response) => {
              let body = JSON.parse(response.data.body)
              this.riders = body.sort(function (a, b) {
                return a.id - b.id
              })

              store.commit('clearRiders')

              for (let rider of this.riders) {
                store.commit('addRider', rider)
              }
            })
            .catch((e) => {
              // console.log(e)
              log(e.toString(), true, 'tmk-products-and-questions.vue created')
              this.errors.push(e)
              this.error = true
            })
        )

        axios
          .all(promises)
          .then(() => {
            this.productsAndRiders = true
          })
          .catch((e) => {
            // console.log(e)
            log(e.toString(), true, 'tmk-products-and-questions.vue created')
            this.errors.push(e)
            this.error = true
          })
      }

      AWS_HTTP.get('questions', {
        params: {
          entity: this.entity.id,
          state: this.entity.state,
        },
      })
        .then((response) => {
          this.questions = response.data[0].questions
          this.prePopulate()
        })
        .catch((e) => {
          // console.log(e)
          log(e.toString(), true, 'tmk-products-and-questions.vue created')
          this.errors.push(e)
          this.error = true
        })

      AWS_HTTP.get('guarantee-issue', {
        params: {},
      })
        .then((response) => {
          let body = JSON.parse(response.data.body)
          this.guaranteeIssue = body
        })
        .catch((e) => {
          // console.log(e)
          log(e.toString(), true, 'tmk-products-and-questions.vue created')
          this.errors.push(e)
          this.error = true
        })
    } catch (e) {
      log(e.toString(), true, 'tmk-products-and-questions.vue created')
      this.error = true
      // console.log(e)
      this.errors.push(e)
    }
  },
  computed: {
    payPeriods: function () {
      try {
        if (
          this.payPeriodsRadio &&
          this.payPeriodsRadio != 'other' &&
          this.payPeriodsRadio != ''
        ) {
          return parseInt(this.payPeriodsRadio)
        } else if (this.payPeriodsRadio.toLowerCase() === 'other') {
          try {
            return parseInt(this.payPeriodsOther)
          } catch (e) {
            log(e.toString(), true, 'tmk-products-and-questions.vue payPeriods')
            return 0
          }
        }
        return 0
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue payPeriods')
        return 0
      }
    },
    estimatedDeduction: function () {
      try {
        return this.premiumsSum * (52 / this.payPeriods)
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue estimatedDeduction'
        )
        return 0
      }
    },
    otherPayPeriodRules: function () {
      try {
        if (this.payPeriodsRadio.toLowerCase() != 'other') {
          return ''
        }

        if (parseInt(this.payPeriodsOther) < 1 || this.payPeriodsOther === '') {
          return 'Please enter a value greater than 0.'
        }

        return ''
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue otherPayPeriodRules'
        )
        return ''
      }
    },
    isNegative: function () {
      // utility computuation to flag the remaining amount as an error field when it goes
      // negative (error flags it in red)
      try {
        return this.remaining < 0 ? true : false
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue isNegative')
        return false
      }
    },
    // remaining: function() {
    //   // Remaining to Spend amount on the Rate Calculator tab.

    //   // Calculated from the preferred desired-to-spend weekly premium total with the
    //   // selected rate sliders' associated premium amounts subtracted from the
    //   // desired to spend amount.

    //   if (this.e1 < 3) return this.budget

    //   let calculatedTotal = 0

    //   if (this.rateRows && this.rateRows.length > 0) {
    //     for (let idx = 0; idx < this.rateRows.length; idx++) {
    //       if (!this.rateRows[idx].rider) {
    //         if (this.rateRows[idx].premiumAmounts === undefined)
    //           return this.budget

    //         if (
    //           !this.rateRows[idx].premiumAmounts[
    //             this.premiumIndexes[idx] === undefined
    //               ? 0
    //               : this.premiumIndexes[idx]
    //           ]
    //         )
    //           return this.budget

    //         calculatedTotal += parseFloat(
    //           this.rateRows[idx].premiumAmounts[
    //             this.premiumIndexes[idx] === undefined
    //               ? 0
    //               : this.premiumIndexes[idx]
    //           ].PremiumPerWeek
    //         )
    //       } else if (this.rateRows[idx].rider.type === 'DFR') {
    //         calculatedTotal += this.DFRPremiumAmount(
    //           this.premiumIndexes[idx] === undefined
    //             ? 0
    //             : this.premiumIndexes[idx],
    //           parseFloat(this.DFRMin),
    //           parseFloat(this.DFRStep)
    //         )
    //       } else if (this.rateRows[idx].rider.coverages) {
    //         calculatedTotal += parseFloat(
    //           this.rateRows[idx].rider.coverages[
    //             this.premiumIndexes[idx] === undefined
    //               ? 0
    //               : this.premiumIndexes[idx]
    //           ].PremiumPerWeek
    //         )
    //       }
    //     }
    //   }
    //   let rem = parseFloat(this.budget) - parseFloat(calculatedTotal)

    //   if (Math.floor(rem) != rem) {
    //     return parseFloat(rem).toFixed(2)
    //   } else {
    //     return rem.toString()
    //   }
    // },

    employee: function () {
      try {
        return this.storedPersons.find(
          (sp) => sp.type.toLowerCase() == 'employee'
        )
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue employee')
        return false
      }
    },
    storedPersons: function () {
      // stored individuals for whom N/A was NOT checked during demographics completion

      let sps = store.getters.applicableIndividuals

      for (let idx = 0; idx < sps.length; idx++) {
        sps[idx].personType = this.getPersonType(sps[idx].type)
      }

      return sps
    },
    eligibleProducts: function () {
      // all stored products
      try {
        return store.state.eligibleProducts.sort(
          (a, b) => a.displayOrder > b.displayOrder
        )
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue eligibleProducts'
        )
        return store.state.eligibleProducts
      }
    },
    summaryHeadersSm: function () {
      return [
        {
          text: 'Signature Requirements',
          value: '',
          align: 'center',
          sortable: false,
        },
      ]
    },
    summaryHeaders: function () {
      // headers for the required to sign table on the Next Step tab

      return [
        {
          text: 'Proposed Insured',
          value: 'name',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Birthdate',
          value: 'dob',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Gender',
          value: 'sex',
          align: 'center',
          sortable: false,
        },
        {
          text: 'E-Mail',
          value: 'email',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Signature Status',
          value: 'sigReq',
          align: 'center',
          sortable: false,
        },
      ]
    },
    summaryRows: function () {
      // row details for the applicant's required to sign table on the next steps tab
      // employee, spouse and child applicants over 18 required to sign.
      try {
        if (this.e1 < 5) return

        let ret = []
        store.commit('clearSummaryRows')

        for (let p = 0; p < this.storedPersons.length; p++) {
          let thisIsTheEmployee = this.storedPersons[p].type === 'employee'
          let rowAddedForEmployee = false
          let rowAdded = false

          if (
            this.selections &&
            this.selections.length > 0 &&
            this.selections[0]
          ) {
            for (let idx = 0; idx < this.selections.length; idx++) {
              let personAndProduct = this.findSelectionInfo(
                this.selections[idx]
              )

              if (
                personAndProduct &&
                personAndProduct.person.id === this.storedPersons[p].id
              ) {
                // find the stored rate for this person's product selection
                let idx = store.state.rates.findIndex(
                  (r) =>
                    r.personId === personAndProduct.person.id &&
                    r.planCodeId === personAndProduct.product.planCodeId
                )

                // initialize the rate to undefined
                personAndProduct.rate = undefined

                // if the rate was found in the store, associate the face amount
                // and weekly premium with the person/product selection object
                // for later use.
                if (idx >= 0) {
                  personAndProduct.rate = {
                    faceAmt: store.state.rates[idx].faceAmt,
                    premium: store.state.rates[idx].premium,
                  }
                } else {
                  continue
                }

                let signatureRequired = 'Not Required'

                if (personAndProduct.product.name.indexOf('Cancer') >= 0) {
                  if (
                    personAndProduct.person.type.toLowerCase() == 'applicant' ||
                    personAndProduct.person.type.toLowerCase() == 'employee'
                  )
                    signatureRequired = 'Required' // employee always signs

                  // let buckets = this.$store.state.cancerAppBuckets

                  // for (let bucket of buckets) {
                  //   if (
                  //     bucket.oldestApplicant.person.id ==
                  //     personAndProduct.person.id
                  //   ) {
                  //     if (
                  //       personAndProduct.person.age >= 19 ||
                  //       personAndProduct.person.type != 'child'
                  //     ) {
                  //       signatureRequired = 'Required'
                  //       break
                  //     }
                  //   }
                  // }
                } else {
                  signatureRequired =
                    logic.getSignatureRequired(
                      personAndProduct,
                      this.guaranteeIssue
                    ) === true
                      ? 'Required'
                      : 'Not Required'
                }

                let retIdx = ret.findIndex(
                  (r) => r.id === personAndProduct.person.id
                )

                if (retIdx < 0) {
                  let tableRow = {
                    id: personAndProduct.person.id,
                    personType: personAndProduct.person.personType,
                    name: personAndProduct.person.name,
                    dob: personAndProduct.person.birthdate,
                    sex: personAndProduct.person.sex,
                    email: personAndProduct.person.email,
                    sigReq: signatureRequired,
                  }

                  ret.push(tableRow)
                  rowAdded = true
                  store.commit('addSummaryRow', tableRow)
                } else {
                  if (ret[retIdx].sigReq === 'Not Required') {
                    ret[retIdx].sigReq = signatureRequired
                  }
                }

                if (thisIsTheEmployee) {
                  rowAddedForEmployee = true
                }

                //break
              }
            }
          }

          // if the employee was not eligible for any products
          // (or simply did not select any products for himself/herself)
          // he/she will not be found in the selections above,
          // but he/she is required to sign the application.
          if (thisIsTheEmployee && !rowAddedForEmployee) {
            let tableRow = {
              personType: 'Applicant',
              name: this.storedPersons[p].name,
              dob: this.storedPersons[p].birthdate,
              sex: this.storedPersons[p].sex,
              email: this.storedPersons[p].email,
              sigReq: 'Required',
            }
            rowAdded = true
            ret.push(tableRow)
            store.commit('addSummaryRow', tableRow)
          }

          // marker 100

          if (!rowAdded) {
            let tableRow = {
              personType:
                this.storedPersons[p].type.charAt(0).toUpperCase() +
                this.storedPersons[p].type.slice(1),
              name: this.storedPersons[p].name,
              dob: this.storedPersons[p].birthdate,
              sex: this.storedPersons[p].sex,
              email: this.storedPersons[p].email,
              sigReq: 'Not Required',
            }

            ret.push(tableRow)
            store.commit('addSummaryRow', tableRow)
          }
        }

        return ret
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue summaryRows')
        return []
      }
    },
    premiumsSum: function () {
      // Total Weekly Premium on the Rates Summary tab's table footer
      try {
        if (!store.state.rates || store.state.rates.length < 1) {
          return 0
        }

        let sum = 0

        for (let idx = 0; idx < store.state.rates.length; idx++) {
          sum += parseFloat(store.state.rates[idx].premium)
        }

        store.commit('setTotalWeeklyPremium', sum)

        return sum
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue premiumsSum')
        return 0
      }
    },
    rateSummaryHeaders: function () {
      // headers for the table on the rate summary tab

      let ret = [
        {
          text: 'Proposed Insured',
          value: 'name',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Plan Description',
          value: 'description',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Estimated Face Amount',
          value: 'faceAmt',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Weekly Premium Amount',
          value: 'premium',
          align: 'center',
          sortable: false,
        },
      ]
      return ret
    },
    rateSummaryRows: function () {
      // detail rows for the table on the rates summary tab
      return store.state.rates
    },
    rateSummaryHeadersSm: function () {
      let ret = []

      ret.push({
        text: 'Summary',
        value: '',
        align: 'center',
        sortable: false,
      })

      return ret
    },
    rateHeaders: function () {
      // Row headers for the table data on the rate calculator tab

      let ret = [
        // {
        //   text: '',
        //   value: 'personType',
        //   align: 'center',
        //   sortable: false
        // },
        {
          text: 'Proposed Insured',
          value: 'name',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Plan Description',
          value: 'description',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Estimated Face Amount',
          value: 'faceAmt',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Weekly Premium Amount',
          value: 'premium',
          align: 'center',
          sortable: false,
        },
        {
          text: '',
          value: '',
          sortable: false,
          width: 5,
        },
      ]
      return ret
    },
    rateHeadersSm: function () {
      let ret = []
      ret.push({
        text: 'Select Premium Amounts',
        value: 'premium',
        align: 'center',
        sortable: false,
      })

      return ret
    },
    rateRows: function () {
      // Row data for the table on the rate calculator tab.
      try {
        if (this.e1 < 3) return

        let ret = []
        let rateRowsIdx = 0
        let curPerson = undefined
        let curProduct = undefined

        let curPersonIdx = -1

        for (let p = 0; p < this.storedPersons.length; p++) {
          for (let x = 0; x < this.eligibleProducts.length; x++) {
            for (let idx = 0; idx < this.selections.length; idx++) {
              let personAndProduct = this.findSelectionInfo(
                this.selections[idx]
              )

              if (personAndProduct === undefined) continue
              if (personAndProduct.rider != undefined) continue

              // if this is a base product

              if (
                personAndProduct &&
                personAndProduct.person.id === this.storedPersons[p].id &&
                personAndProduct.product.productId ==
                  this.eligibleProducts[x].productId &&
                personAndProduct.product.planCodeId ===
                  this.eligibleProducts[x].planCodeId
              ) {
                if (curPerson === undefined)
                  curPerson = personAndProduct.person.id
                if (curProduct === undefined)
                  curProduct = personAndProduct.product.planCodeId

                if (
                  curPerson != personAndProduct.person.id ||
                  curProduct != personAndProduct.product.planCodeId
                ) {
                  // We've changed people or products
                  for (let rider of this.riders) {
                    for (let r = 0; r < this.selections.length; r++) {
                      let personAndProduct2 = this.findSelectionInfo(
                        this.selections[r]
                      )

                      if (personAndProduct2 === undefined) continue
                      if (personAndProduct2.rider === undefined) continue
                      if (personAndProduct2.rider.id === undefined) continue

                      // if this is a rider:
                      if (
                        personAndProduct2.person.id === curPerson &&
                        personAndProduct2.rider.planCodes.findIndex(
                          (p) => p === curProduct
                        ) >= 0 &&
                        personAndProduct2.rider.id === rider.id
                      ) {
                        let premiums = []
                        for (let coverage of personAndProduct2.rider.coverages)
                          premiums.push(coverage)

                        let tableRow = {
                          personType: personAndProduct2.person.personType,

                          name: personAndProduct2.person.name,
                          personId: personAndProduct2.person.id,
                          age: personAndProduct2.person.age,
                          description: personAndProduct2.rider.name,
                          productId: personAndProduct2.rider.productId,
                          planCodeId:
                            personAndProduct2.rider.planCodes.join('_'),
                          premium: 0,
                          premiumAmounts: premiums,
                          rider: personAndProduct2.rider,
                          product: personAndProduct2.product,
                        }

                        ret.push(tableRow)
                        rateRowsIdx = rateRowsIdx + 1
                      }
                    }
                  }
                }

                curPerson = personAndProduct.person.id
                curProduct = personAndProduct.product.planCodeId

                let premiums = undefined

                // marker 100

                let cancerNote = undefined

                if (personAndProduct.product.name.indexOf('Cancer') >= 0) {
                  premiums = []

                  let buckets = this.$store.state.cancerAppBuckets
                  let found = false
                  for (let bucket of buckets) {
                    if (
                      bucket.oldestApplicant.person.id ==
                      personAndProduct.person.id
                    ) {
                      found = true

                      if (this.ratesTable) {
                        for (let x = 0; x < this.ratesTable.length; x++) {
                          if (this.ratesTable[x][0]) {
                            if (
                              this.ratesTable[x][0].Product_ID ==
                                personAndProduct.product.productId &&
                              this.ratesTable[x][0].PlanCode_ID ==
                                bucket.planCodeId &&
                              this.ratesTable[x][0].IssueAge ==
                                personAndProduct.person.age &&
                              this.ratesTable[x][0].Gender ==
                                personAndProduct.person.sex
                            ) {
                              premiums = this.ratesTable[x]
                            }
                          }
                        }
                      }

                      break
                    }
                  }

                  if (!found && buckets[0]) {
                    cancerNote =
                      'Included with cancer policy rates for ' +
                      buckets[0].oldestApplicant.person.name +
                      '.'
                  }
                } else {
                  if (this.ratesTable) {
                    for (let x = 0; x < this.ratesTable.length; x++) {
                      if (this.ratesTable[x][0]) {
                        if (
                          this.ratesTable[x][0].Product_ID ==
                            personAndProduct.product.productId &&
                          this.ratesTable[x][0].PlanCode_ID ==
                            personAndProduct.product.planCodeId &&
                          this.ratesTable[x][0].IssueAge ==
                            personAndProduct.person.age
                        ) {
                          premiums = this.ratesTable[x]
                        }
                      }
                    }
                  }
                }

                if (premiums || personAndProduct.product.noRates == true) {
                  if (personAndProduct.product.noRates == true) {
                    premiums = []

                    if (personAndProduct.product.specialPremium != undefined) {
                      let premiumNode = {
                        Id: 1,
                        PremiumPerWeek: personAndProduct.product.specialPremium,
                        FaceAmount: '',
                      }
                      premiums.push(premiumNode)
                    }
                  }

                  // marker

                  let name = ''

                  if (curPersonIdx != p) {
                    name = personAndProduct.person.name
                    curPersonIdx = p
                  }

                  let tableRow = {
                    personType: personAndProduct.person.personType,
                    name: personAndProduct.person.name,
                    displayName: name,
                    personId: personAndProduct.person.id,
                    age: personAndProduct.person.age,
                    description: personAndProduct.product.name,
                    productId: personAndProduct.product.productId,
                    planCodeId: personAndProduct.product.planCodeId,
                    premium: 0,
                    premiumAmounts: premiums,
                    rider: undefined,
                    product: personAndProduct.product,
                    cancer: cancerNote,
                  }

                  // if (personAndProduct.product.name.indexOf('Cancer') >= 0) {
                  //   if (
                  //     personAndProduct.person.name !=
                  //       this.oldestCancerApplicant.person.name ||
                  //     personAndProduct.person.birthdate !=
                  //       this.oldestCancerApplicant.person.birthdate
                  //   ) {
                  //     tableRow.premiums = []
                  //     tableRow.cancer =
                  //       'Included with cancer policy rates for ' +
                  //       this.oldestCancerApplicant.person.name +
                  //       '.'
                  //   }
                  // }
                  ret.push(tableRow)
                  rateRowsIdx = rateRowsIdx + 1
                }
              }
            }
          }
        }

        for (let rider of this.riders) {
          for (let idx = 0; idx < this.selections.length; idx++) {
            let personAndProduct = this.findSelectionInfo(this.selections[idx])
            let premiums = []

            if (personAndProduct === undefined) continue
            if (personAndProduct.rider === undefined) continue
            if (personAndProduct.rider.id === undefined) continue

            if (
              personAndProduct.rider.planCodes.findIndex(
                (p) => p == curProduct
              ) >= 0 &&
              personAndProduct.person.id === curPerson &&
              personAndProduct.rider.id === rider.id
            ) {
              for (let coverage of personAndProduct.rider.coverages)
                premiums.push(coverage)

              let tableRow = {
                personType: personAndProduct.person.personType,
                name: personAndProduct.person.name,
                displayName: '',
                personId: personAndProduct.person.id,
                age: personAndProduct.person.age,
                description: rider.name,
                productId: rider.productId,
                planCodeId: rider.planCodes.join('_'),
                premium: 0,
                premiumAmounts: premiums,
                rider: rider,
                product: personAndProduct.product,
              }

              ret.push(tableRow)
              rateRowsIdx = rateRowsIdx + 1
            }
          }
        }

        return ret
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue rateRows')
        return []
      }
    },
    headers: function () {
      let ret = []

      ret.push({
        text: 'Product Offering',
        value: 'product.name',
        align: 'left',
        sortable: false,
        width: '350',
      })

      for (let idx = 0; idx < this.storedPersons.length; idx++) {
        ret.push({
          text: this.storedPersons[idx].firstName.split(' ')[0],
          value: this.storedPersons[idx].name,
          align: 'left',
          sortable: false,
          width: '200',
        })
      }

      return ret
    },
    productRows: function () {
      try {
        let ret = []
        let counter = 0

        for (let product of this.eligibleProducts) {
          counter += 1
          let tableRow = {
            index: counter,
            product: product,
            rider: {},
            people: [],
            expandMe: false,
          }

          for (let idx = 0; idx < this.storedPersons.length; idx++) {
            tableRow.people.push({
              name: this.storedPersons[idx].firstName.split(' ')[0],
              personType: this.storedPersons[idx].personType,
              type: this.storedPersons[idx].type,
              age: this.storedPersons[idx].age,
              ageInDays: this.storedPersons[idx].ageInDays,
              id: this.storedPersons[idx].id,
            })
          }

          ret.push(tableRow)
        }

        for (let row of ret) {
          row.riders = []

          let applicableRiders = this.riders.filter(
            (r) =>
              r.productId == row.product.productId &&
              r.planCodes.findIndex((p) => p == row.product.planCodeId) >= 0
          )

          for (let r = 0; r < applicableRiders.length; r++) {
            counter += 1
            let tableRow = {
              index: counter,
              product: {
                name: '',
                planCodeId: applicableRiders[r].planCodes.join('_'),
                productId: applicableRiders[r].productId,
                minAgeDays: 0,
                maxAgeDays: null,
                minAgeYears: null,
                maxAgeYears: 200,
                excludesProducts: [],
              },
              rider: applicableRiders[r],
              people: [],
            }

            for (let idx = 0; idx < this.storedPersons.length; idx++) {
              tableRow.people.push({
                name: this.storedPersons[idx].name,
                personType: this.storedPersons[idx].personType,
                type: this.storedPersons[idx].type,
                age: this.storedPersons[idx].age,
                ageInDays: this.storedPersons[idx].ageInDays,
                id: this.storedPersons[idx].id,
              })
            }

            row.riders.push(tableRow)

            row.headers = []

            row.headers.push({
              text: row.product.name + ' Riders',
              value: 'product.name',

              align: 'left',
              sortable: false,
              width: '350',
            })

            for (let person of row.people) {
              row.headers.push({
                text: '',
                value: person.id,
                align: 'left',
                sortable: false,
                width: '200',
              })
            }

            row.filteredHeadersForRiders = []

            row.filteredHeadersForRiders.push({
              text: row.product.name + ' Riders',
              value: 'product.name',
              align: 'left',
              sortable: false,
              class: 'text-wrap',
              width: '70%',
            })

            row.filteredHeadersForRiders.push({
              text: '',
              value: '0',
              align: 'left',
              sortable: false,
              class: 'text-wrap',
              width: '30%',
            })
          }
        }

        let found = false

        for (let row of ret) {
          found = false

          for (let sel of this.selections) {
            let prodAndPerson = this.findSelectionInfo(sel)

            if (
              prodAndPerson &&
              prodAndPerson.product.productId == row.product.productId &&
              prodAndPerson.product.planCodeId == row.product.planCodeId
            ) {
              found = true
              break
            }
          }

          row.expandMe = found
          //this.$refs.productTableRow.click();
        }

        return ret
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue productRows')
        return []
      }
    },
  },
  watch: {
    storedPersons: function () {
      try {
        let removeArray = []

        for (let idx = 0; idx < this.selections.length; idx++) {
          // marker 99
          let selection = this.selections[idx]

          let details = selection.split('|')
          let personId = -1

          if (details.length >= 3) {
            personId = details[2]
          }

          let found = false

          for (let sp of this.storedPersons) {
            if (sp.id == personId) found = true
          }

          if (!found) removeArray.push(idx)
        }

        for (let rem of removeArray) {
          this.selections.splice(rem, 1)
        }
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue storedPersons')
        this.error = true
        // console.log(e)
        this.errors.push(e)
      }
    },
    payPeriodsRadio: function () {
      if (this.payPeriodsRadio != 'other') this.payPeriodsOther = ''
      store.commit('setPayPeriodsRadio', this.payPeriodsRadio)
      store.commit('setPaycheckDeductions', this.estimatedDeduction)
      store.commit('setPayPeriodsOther', this.payPeriodsOther)
    },
    payPeriodsOther: function () {
      store.commit('setPayPeriodsOther', this.payPeriodsOther)
    },
    // selections: function () {
    //   console.log('selections watch called')

    //   // if selections change, make sure the applicant has to re-visit the rate selection page
    //   try {
    //     if (!this.initialize) {
    //       if (store.state.maxTab > 4) store.commit('setMaxTab', 4)
    //     }

    //     this.doubleCheckSelections()

    //     let found = false
    //     let productsArray = []

    //     for (let row of this.productRows) {
    //       found = false

    //       if (this.selections) {
    //         for (let sel of this.selections) {
    //           let prodAndPerson = this.findSelectionInfo(sel)

    //           if (
    //             prodAndPerson &&
    //             prodAndPerson.product.productId == row.product.productId &&
    //             prodAndPerson.product.planCodeId == row.product.planCodeId
    //           ) {
    //             found = true
    //           }

    //           if (sel.endsWith('|')) productsArray.push(sel)
    //         }
    //       }

    //       row.expandMe = found
    //     }

    //     this.initialize = false

    //     let types = ['employee', 'spouse', 'child']

    //     for (let type of types) {
    //       let people = this.getPeople(type)
    //       if (people && people.length > 0) {
    //         for (let person of people) {
    //           for (let rider of this.riders) {
    //             if (rider.eligibility) {
    //               if (rider.eligibility[type]) {
    //                 if (
    //                   rider.eligibility[type].condition === 'always' ||
    //                   rider.eligibility[type].condition === 'always|age'
    //                 ) {
    //                   if (!this.riderAgeExcluded(person, rider)) {
    //                     let foundPlan = false
    //                     if (rider.planCodes) {
    //                       for (let planCode of rider.planCodes) {
    //                         // proposed insured + plan
    //                         let sel =
    //                           rider.productId.toString() +
    //                           '|' +
    //                           planCode +
    //                           '|' +
    //                           person.id +
    //                           '|'

    //                         // if a plan is checked for this insured

    //                         let selIdx = this.selections.findIndex(
    //                           (s) => s === sel
    //                         )

    //                         if (selIdx != undefined && selIdx >= 0) {
    //                           foundPlan = true

    //                           break
    //                         }
    //                       }

    //                       // proposed insured + rider

    //                       let auto =
    //                         rider.productId.toString() +
    //                         '|' +
    //                         rider.planCodes.join('_') +
    //                         '|' +
    //                         person.id +
    //                         '|' +
    //                         rider.id

    //                       if (foundPlan === true) {
    //                         // if the auto rider is not checked

    //                         let autoIdx = this.selections.findIndex(
    //                           (s) => s === auto
    //                         )

    //                         if (autoIdx < 0) {
    //                           // check the auto rider
    //                           this.selections.push(auto)
    //                         }
    //                       } else {
    //                         // no plan is selected, uncheck the auto rider
    //                         this.removeSelection(
    //                           person,
    //                           rider.productId,
    //                           rider.planCodes.join('_'),
    //                           rider
    //                         )
    //                       }
    //                     }
    //                   }
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   } catch (e) {
    //     log(e.toString(), true, 'tmk-products-and-questions.vue selections')
    //     this.errors = true
    //   }
    // },
    ratesTable: function () {
      // when the async call to the web service returns (and updates the ratesTable)
      // update the rateRows premiums with the returned data.
      try {
        if (!this.rateRows || this.rateRows.length == 0) {
          return
        }

        for (let idx = 0; idx < this.rateRows.length; idx++) {
          if (this.rateRows[idx].rider && this.rateRows[idx].rider.id) continue
          if (this.rateRows[idx].product.noRates == true) continue

          let premiums = undefined

          // ratesTable is the data returned from the API for all requested
          // products and ages...
          // ratesTable[n] represents an array of premiums/face amounts/etc
          // for a given product and age.
          // ratesTable is not to be confused with rateRows, which is the data
          // used to display the rates table grid in the UI.

          if (this.ratesTable) {
            for (let i = 0; i < this.ratesTable.length; i++) {
              if (this.ratesTable[i][0] === undefined) continue

              if (this.ratesTable[i][0]) {
                if (
                  this.ratesTable[i][0].Product_ID ==
                    this.rateRows[idx].productId &&
                  this.ratesTable[i][0].PlanCode_ID ==
                    this.rateRows[idx].planCodeId &&
                  this.ratesTable[i][0].IssueAge == this.rateRows[idx].age
                ) {
                  premiums = this.ratesTable[i]
                }
              }
            }
          }

          let rateRow = this.rateRows[idx] // grab existing info
          rateRow.premiumAmounts = premiums // update the premiums array for the slider

          // update the rateRows array (replace rateRows[idx] with rateRow)
          this.rateRows.splice(idx, 1, rateRow)
        }
        this.setStoredRate()

        if (this.ratesLoaded) this.calculateRemaining()
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue ratesTable')
        this.error = true
        // console.log(e)
        this.errors.push(e)
      }
    },
  },
  methods: {
    watchSelections: function () {
      // if selections change, make sure the applicant has to re-visit the rate selection page
      try {
        if (!this.initialize) {
          if (store.state.maxTab > 4) store.commit('setMaxTab', 4)
        }

        this.doubleCheckSelections()

        let found = false
        let productsArray = []

        for (let row of this.productRows) {
          found = false

          if (this.selections) {
            for (let sel of this.selections) {
              let prodAndPerson = this.findSelectionInfo(sel)

              if (
                prodAndPerson &&
                prodAndPerson.product.productId == row.product.productId &&
                prodAndPerson.product.planCodeId == row.product.planCodeId
              ) {
                found = true
              }

              if (sel.endsWith('|')) productsArray.push(sel)
            }
          }

          row.expandMe = found
        }

        this.initialize = false

        let types = ['employee', 'spouse', 'child']

        for (let type of types) {
          let people = this.getPeople(type)
          if (people && people.length > 0) {
            for (let person of people) {
              for (let rider of this.riders) {
                if (rider.eligibility) {
                  if (rider.eligibility[type]) {
                    if (
                      rider.eligibility[type].condition === 'always' ||
                      rider.eligibility[type].condition === 'always|age'
                    ) {
                      if (!this.riderAgeExcluded(person, rider)) {
                        let foundPlan = false
                        if (rider.planCodes) {
                          for (let planCode of rider.planCodes) {
                            // proposed insured + plan
                            let sel =
                              rider.productId.toString() +
                              '|' +
                              planCode +
                              '|' +
                              person.id +
                              '|'

                            // if a plan is checked for this insured

                            let selIdx = this.selections.findIndex(
                              (s) => s === sel
                            )

                            if (selIdx != undefined && selIdx >= 0) {
                              foundPlan = true

                              break
                            }
                          }

                          // proposed insured + rider

                          let auto =
                            rider.productId.toString() +
                            '|' +
                            rider.planCodes.join('_') +
                            '|' +
                            person.id +
                            '|' +
                            rider.id

                          if (foundPlan === true) {
                            // if the auto rider is not checked

                            let autoIdx = this.selections.findIndex(
                              (s) => s === auto
                            )

                            if (autoIdx < 0) {
                              // check the auto rider
                              this.selections.push(auto)
                            }
                          } else {
                            // no plan is selected, uncheck the auto rider
                            this.removeSelection(
                              person,
                              rider.productId,
                              rider.planCodes.join('_'),
                              rider
                            )
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue selections')
        this.errors = true
      }
    },
    switchStepFromDialog() {
      try {
        this.setMaxTab(this.currentTabIndex)
        this.e1 = this.currentTabIndex

        // if we've just moved to tab 3 based on the above logic,
        // update its sliders with the stored rates:
        if (this.e1 === 4) {
          this.waitDialog = true
          this.getRates()
          this.setStoredRate()
        }

        window.scrollTo(0, 0)

        this.$store.commit('setProductsPage', this.e1)
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue switchStepFromDialog'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
      }
    },
    parseDate(date) {
      try {
        if (!date) return null

        if (!/^\d{2}\/\d{2}\/\d{4}/.test(date)) return null

        const [month, day, year] = date.split('/')

        if (!year || !month || !day) return null

        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue parseDate')
        return null
      }
    },
    calculateRemaining() {
      this.remaining = this.getRemainingAmt()
    },
    getRemainingAmt() {
      // Remaining to Spend amount on the Rate Calculator tab.

      // Calculated from the preferred desired-to-spend weekly premium total with the
      // selected rate sliders' associated premium amounts subtracted from the
      // desired to spend amount.
      try {
        if (this.e1 < 3) return this.budget

        let calculatedTotal = 0

        if (this.rateRows && this.rateRows.length > 0) {
          for (let idx = 0; idx < this.rateRows.length; idx++) {
            if (this.rateRows[idx].cancer != undefined) {
              continue
            }

            if (!this.rateRows[idx].rider) {
              if (this.rateRows[idx].premiumAmounts === undefined) {
                return this.budget
              }

              if (
                !this.rateRows[idx].premiumAmounts[
                  this.premiumIndexes[idx] === undefined
                    ? 0
                    : this.premiumIndexes[idx]
                ]
              )
                return
              {
                this.budget
              }

              calculatedTotal += parseFloat(
                this.rateRows[idx].premiumAmounts[
                  this.premiumIndexes[idx] === undefined
                    ? 0
                    : this.premiumIndexes[idx]
                ].PremiumPerWeek
              )
            } else if (this.rateRows[idx].rider.type === 'DFR') {
              calculatedTotal += this.DFRPremiumAmount(
                this.premiumIndexes[idx] === undefined
                  ? 0
                  : this.premiumIndexes[idx],
                parseFloat(this.DFRMin),
                parseFloat(this.DFRStep)
              )
            } else if (this.rateRows[idx].rider.coverages) {
              calculatedTotal += parseFloat(
                this.rateRows[idx].rider.coverages[
                  this.premiumIndexes[idx] === undefined
                    ? 0
                    : this.premiumIndexes[idx]
                ].PremiumPerWeek
              )
            }
          }
        }
        let rem = parseFloat(this.budget) - parseFloat(calculatedTotal)

        if (Math.floor(rem) != rem) {
          return parseFloat(rem).toFixed(2)
        } else {
          return rem.toString()
        }
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue getRemainingAmt'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return 0
      }
    },
    doubleCheckSelections() {
      try {
        let productArray = []

        if (this.selections) {
          for (let sel of this.selections) {
            if (sel.endsWith('|')) {
              productArray.push(sel)
            }
          }

          let len = this.selections.length

          for (let i = 0; i < len; i++) {
            let productFound = false

            let sel = this.selections[i]

            if (!sel.endsWith('|')) {
              for (let product of productArray) {
                if (sel.startsWith(product)) {
                  productFound = true
                }
              }

              if (!productFound) {
                let idx = this.selections.findIndex((s) => s === sel)

                if (idx >= 0) {
                  this.selections.splice(idx, 1)
                  len = this.selections.length
                  i--
                }
              }
            }
          }
        }
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue doubleCheckSelections'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
      }
    },
    productIsSelected(person, item) {
      try {
        let selection =
          item.product.productId.toString() +
          '|' +
          item.product.planCodeId.toString() +
          '|' +
          person.id +
          '|' +
          (item.rider != undefined && item.rider.id != undefined
            ? item.rider.id.toString()
            : '')

        if (this.selections.findIndex((s) => s === selection) >= 0) return true

        return false
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue productIsSelected'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return false
      }
    },
    meetsAgeReqs(person, ageReqs) {
      try {
        let exclude = false
        if (ageReqs.minAgeDays) {
          if (person.ageInDays && person.ageInDays < ageReqs.minAgeDays)
            exclude = true
        }
        if (ageReqs.maxAgeDays) {
          if (person.ageInDays && person.ageInDays > ageReqs.maxAgeDays)
            exclude = true
        }
        if (ageReqs.maxAgeYears) {
          if (person.age > ageReqs.maxAgeYears) exclude = true
        }
        if (ageReqs.minAgeYears) {
          if (person.age < ageReqs.minAgeYears) exclude = true
        }
        return !exclude
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue meetsAgeReqs')
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return false
      }
    },
    childEligibleByAge(person, product) {
      try {
        if (
          person.type.toLowerCase() === 'child' &&
          product.requirements &&
          product.requirements.employee &&
          product.requirements.employee.age_child != 'undefined'
        ) {
          if (
            this.meetsAgeReqs(person, product.requirements.employee.age_child)
          )
            return true
        }

        return false
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue childEligibleByAge'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return false
      }
    },
    childEligible(person, rider, product) {
      try {
        let excludedByEmployeeAndSpouse = true

        for (let sp of this.storedPersons) {
          if (
            sp.type.toLowerCase() == 'employee' ||
            sp.type.toLowerCase() == 'applicant' ||
            sp.type.toLowerCase() == 'spouse'
          ) {
            if (
              !this.disableCheckbox(
                sp,
                product.productId,
                product.planCodeId,
                rider
              ) &&
              !this.productExcludedForInsured(sp, product, rider) &&
              !this.excludeRidersBasedOnNAProducts(sp, rider)
            ) {
              excludedByEmployeeAndSpouse = false
              break
            }
          }
        }

        if (person.type.toLowerCase() != 'child') return 'false'

        if (
          person.type.toLowerCase() === 'child' &&
          rider.requirements &&
          rider.requirements.employee &&
          rider.requirements.employee.age_child != 'undefined'
        ) {
          if (
            this.meetsAgeReqs(person, rider.requirements.employee.age_child)
          ) {
            if (excludedByEmployeeAndSpouse) return 'NA'
            else return 'true'
          }
        }
        if (excludedByEmployeeAndSpouse) return 'NA'
        return 'false'
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue childEligible')
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return 'false'
      }
    },
    nonDFRTotalPremiums() {
      try {
        let total = 0

        for (let idx = 0; idx < this.rateRows.length; idx++) {
          if (this.rateRows.rider && this.rateRows.rider.type === 'DFR')
            continue
          if (this.rateRows.cancer != undefined) continue

          total += parseFloat(
            (
              this.rateRows[idx].premiumAmounts === undefined
                ? 0
                : this.rateRows[idx].premiumAmounts[
                    this.premiumIndexes[idx] === undefined
                      ? 0
                      : this.premiumIndexes[idx]
                  ]
            )
              ? this.rateRows[idx].premiumAmounts === undefined
                ? 0
                : this.rateRows[idx].premiumAmounts[
                    this.premiumIndexes[idx] === undefined
                      ? 0
                      : this.premiumIndexes[idx]
                  ].PremiumPerWeek
              : 0
          )
        }

        if (total < 20) return 20
        else return total
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue nonDFRTotalPremiums'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return 20
      }
    },
    associatedFaceAmount(rateRow) {
      try {
        for (let idx = 0; idx < this.rateRows.length; idx++) {
          if (this.rateRows[idx].rider === undefined) {
            // find the right insured
            if (this.rateRows[idx].personId === rateRow.personId) {
              // double check the plan
              if (
                rateRow.rider &&
                rateRow.rider.planCodes.findIndex(
                  (p) => p === this.rateRows[idx].planCodeId
                ) >= 0
              ) {
                return this.rateRows[idx].premiumAmounts === undefined
                  ? 0
                  : this.rateRows[idx].premiumAmounts[
                      this.premiumIndexes[idx] === undefined
                        ? 0
                        : this.premiumIndexes[idx]
                    ].FaceAmount
              }
            }
          }
        }
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue associatedFaceAmount'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return 0
      }
    },
    excludeRidersBasedOnNAProducts(person, rider) {
      try {
        if (!rider || !rider.planCodes) return false

        let hasProductListing = false

        for (let prod of this.eligibleProducts) {
          if (
            rider.planCodes.findIndex((p) => p === prod.planCodeId) >= 0 &&
            !this.productExcludedForInsured(person, prod, undefined)
          ) {
            hasProductListing = true
          }
        }

        if (!hasProductListing) return true

        return false
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue excludeRidersBasedOnNAProducts'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return false
      }
    },
    getPeople(type) {
      try {
        return this.storedPersons.filter(
          (s) => s.type.toLowerCase() === type.toLowerCase()
        )
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue getPeople')
        return this.storedPersons
      }
    },
    isDigitKeypress($event) {
      try {
        let charCode = $event.keyCode ? $event.keyCode : $event.which
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          $event.preventDefault()
        }
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue isDigitKeypress'
        )
        return
      }
    },
    filteredHeaders(person) {
      let ret = []

      ret.push({
        text: 'Plan Description',
        value: 'product.name',
        align: 'left',
        sortable: false,
        class: 'text-wrap',
        width: '70%',
      })

      for (let idx = 0; idx < this.storedPersons.length; idx++) {
        if (this.storedPersons[idx].id === person.id) {
          ret.push({
            text: this.storedPersons[idx].firstName,
            value: this.storedPersons[idx].name,
            align: 'left',
            sortable: false,
            class: 'text-wrap',
            width: '30%',
          })
        }
      }

      return ret
    },
    filteredProductRows(person) {
      try {
        let allRows = this.productRows
        let ret = []

        for (let eachRow of allRows) {
          let tableRow = {
            product: eachRow.product,
            people: eachRow.people.filter((p) => p.id === person.id),
            rider: eachRow.rider,
            riders: [],
            expandMe: eachRow.expandMe,
            index: eachRow.index,
            filteredHeadersForRiders: eachRow.filteredHeadersForRiders,
          }

          for (let rider of eachRow.riders) {
            let riderRow = {
              product: rider.product,
              people: rider.people.filter((p) => p.id === person.id),
              rider: rider.rider,
            }

            tableRow.riders.push(riderRow)
          }

          ret.push(tableRow)
        }

        return ret
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue filteredProductRows'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return []
      }
    },
    getPersonType(type) {
      // Convert person type 'employee' to 'applicant' and uppercase the first letter
      // of all types for display purposes.
      try {
        let personType = type

        if (personType.toLowerCase() === 'employee') personType = 'applicant'

        personType = personType.charAt(0).toUpperCase() + personType.slice(1)

        return personType
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue getPersonType')
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return ''
      }
    },
    removeSelection(person, productId, planCodeId, rider) {
      try {
        if (this.selections) {
          let index =
            productId.toString() +
            '|' +
            planCodeId.toString() +
            '|' +
            person.id +
            '|'

          if (rider) {
            if (rider.planCodes) {
              index =
                productId.toString() +
                '|' +
                rider.planCodes.join('_') +
                '|' +
                person.id +
                '|' +
                rider.id
            }
          }

          let idx = this.selections.findIndex((s) => s === index)

          if (idx >= 0) {
            this.selections.splice(idx, 1)
          }
        }
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue removeSelection'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
      }
    },
    disableCheckbox(person, productId, planCodeId, rider) {
      // if a selected product having been selected prevents
      // another product from being an option, return true for the
      // excluded product (incoming product/plancode id)
      try {
        let exclude = false

        if (rider != undefined) {
          // Riders only triggered by policy selection:

          let foundIt = false

          if (rider.planCodes) {
            for (let planCode of rider.planCodes) {
              let planSelection =
                rider.productId + '|' + planCode + '|' + person.id + '|'

              if (this.selections) {
                let idx = this.selections.findIndex((s) => s === planSelection)

                if (idx != undefined && idx >= 0) {
                  foundIt = true
                }
              }
            }

            if (foundIt === false) {
              this.removeSelection(person, productId, planCodeId, rider)
              return true
            }
          }

          let types = ['employee', 'spouse', 'child']

          if (rider.eligibility != undefined) {
            // handle disabling the "always cases"

            for (let type of types) {
              if (person.type.toLowerCase() === type.toLowerCase()) {
                if (
                  rider.eligibility[type] &&
                  rider.eligibility[type].condition
                ) {
                  let conditions = rider.eligibility[type].condition.split('|')

                  if (conditions.findIndex((c) => c.trim() === 'always') >= 0) {
                    return true // and do not remove this selection
                  }
                }
              }
            }
          }

          if (rider.requirements != undefined) {
            for (let type of types) {
              if (person.type.toLowerCase() === type) {
                if (
                  rider.requirements[type] &&
                  rider.requirements[type].condition
                ) {
                  let conditions = rider.requirements[type].condition.split('|')

                  if (
                    conditions.findIndex((c) => c.trim() === 'exclude') >= 0
                  ) {
                    for (let excludedBy of rider.requirements[type]
                      .excludedBy) {
                      if (excludedBy == 'sameRider') {
                        for (let sel of this.selections) {
                          if (sel.endsWith('|')) continue

                          let personAndProduct = this.findSelectionInfo(sel)

                          if (
                            personAndProduct.rider &&
                            personAndProduct.rider.type.toUpperCase() ==
                              rider.type.toUpperCase() &&
                            (personAndProduct.rider.id != rider.id ||
                              personAndProduct.person.id != person.id)
                          ) {
                            exclude = true
                          }
                        }
                      } else {
                        let foundIt = false
                        let people = this.storedPersons.filter(
                          (p) =>
                            p.type.toLowerCase() === excludedBy.toLowerCase()
                        )

                        for (let person of people) {
                          let excludedByPersonId = person.id

                          let excludedBySelection =
                            rider.productId +
                            '|' +
                            rider.planCodes.join('_') +
                            '|' +
                            excludedByPersonId +
                            '|' +
                            rider.id

                          let excludedByIdx = this.selections.findIndex(
                            (s) => s === excludedBySelection
                          )

                          if (
                            excludedByIdx != undefined &&
                            excludedByIdx >= 0
                          ) {
                            foundIt = true
                          }

                          if (foundIt === true) {
                            exclude = true
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        if (exclude) {
          this.removeSelection(person, productId, planCodeId, rider)
          return true
        }

        if (
          !this.selections ||
          this.selections.length === 0 ||
          this.selections[0] === undefined
        )
          return false

        for (let idx = 0; idx < this.selections.length; idx++) {
          let personAndProduct = this.findSelectionInfo(this.selections[idx])

          if (personAndProduct) {
            if (
              personAndProduct.person.id != person.id &&
              personAndProduct.product.productId === productId &&
              personAndProduct.product.planCodeId === planCodeId &&
              (!rider || !rider.id) &&
              (!personAndProduct.rider || !personAndProduct.rider.id)
            ) {
              if (personAndProduct.product.requirements != undefined) {
                let types = ['employee', 'spouse', 'child']

                for (let type of types) {
                  if (person.type.toLowerCase() === type) {
                    if (
                      personAndProduct.product.requirements[type] &&
                      personAndProduct.product.requirements[type].condition
                    ) {
                      let conditions =
                        personAndProduct.product.requirements[
                          type
                        ].condition.split('|')

                      if (
                        conditions.findIndex((c) => c.trim() === 'exclude') >= 0
                      ) {
                        for (let excludedBy of personAndProduct.product
                          .requirements[type].excludedBy) {
                          let people = this.storedPersons.filter(
                            (p) =>
                              p.type.toLowerCase() === excludedBy.toLowerCase()
                          )
                          for (let excludedperson of people) {
                            let excludedByPersonId = excludedperson.id

                            let excludedBySelection =
                              personAndProduct.product.productId +
                              '|' +
                              personAndProduct.product.planCodeId +
                              '|' +
                              excludedByPersonId +
                              '|'

                            let excludedByIdx = this.selections.findIndex(
                              (s) => s === excludedBySelection
                            )

                            if (
                              excludedByIdx != undefined &&
                              excludedByIdx >= 0
                            ) {
                              this.removeSelection(
                                person,
                                productId,
                                planCodeId,
                                rider
                              )
                              return true
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            if (personAndProduct.product.excludesProducts) {
              for (
                let e = 0;
                e < personAndProduct.product.excludesProducts.length;
                e++
              ) {
                if (
                  personAndProduct.person.id === person.id &&
                  personAndProduct.product.excludesProducts[e].productId ==
                    productId &&
                  personAndProduct.product.excludesProducts[e].planCodeId ==
                    planCodeId
                ) {
                  this.removeSelection(person, productId, planCodeId, rider)
                  return true
                }
              }
            }
          }
        }
        return false
      } catch (e) {
        // console.log(e)
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue disableCheckbox'
        )
        this.errors.push(e)
        this.error = true
        return false
      }
    },
    setStoredRate() {
      try {
        // Restore saved weekly premium preferences and individual rate preferences
        // from the store to the UI controls

        if (store.state.weeklyPremiumPreference) {
          this.budget = store.state.weeklyPremiumPreference
        }

        if (
          !this.rateRows ||
          !store.state.rates ||
          store.state.rates.length < 1
        ) {
          return
        }

        this.premiumIndexes = []

        for (let idx = 0; idx < store.state.rates.length; idx++) {
          for (let r = 0; r < this.rateRows.length; r++) {
            // check if this rows rates have returned from the API
            if (this.rateRows[r].premiumAmounts === undefined) continue

            // if there's not an index slot for this row, push 0 as a starting index value
            if (this.premiumIndexes[r] === undefined)
              this.premiumIndexes.push(0)

            if (
              this.rateRows[r].personId === store.state.rates[idx].personId &&
              this.rateRows[r].productId === store.state.rates[idx].productId &&
              this.rateRows[r].planCodeId === store.state.rates[idx].planCodeId
            ) {
              // this stored rate selection appears to match to this row's person and product
              // now find the index into the premium amounts that matches the stored premium.
              for (let m = 0; m < this.rateRows[r].premiumAmounts.length; m++) {
                if (this.rateRows[r].premiumAmounts[m] === undefined) continue

                if (
                  this.rateRows[r].premiumAmounts[m].PremiumPerWeek ===
                  store.state.rates[idx].premium
                ) {
                  // the premiums match, update the index of the slider.
                  this.premiumIndexes[r] = m
                  break
                }
              }
            }
          }
        }

        for (let idx = 0; idx < store.state.rates.length; idx++) {
          for (let r = 0; r < this.rateRows.length; r++) {
            if (
              this.rateRows[r].rider &&
              this.rateRows[r].rider.type === 'DFR'
            ) {
              if (this.premiumIndexes[r] === undefined) {
                // if there's not an index slot for this row, push 0 as a starting index value
                this.premiumIndexes.push(0)
              }

              if (
                this.rateRows[r].personId === store.state.rates[idx].personId &&
                this.rateRows[r].productId ===
                  store.state.rates[idx].productId &&
                this.rateRows[r].planCodeId ===
                  store.state.rates[idx].planCodeId &&
                this.rateRows[r].rider.id === store.state.rates[idx].rider.id
              ) {
                // this stored rate selection appears to match to this row's person and product
                // now find the index into the premium amounts that matches the stored premium.

                this.premiumIndexes[r] = this.DFRIndex(
                  parseFloat(store.state.rates[idx].premium),
                  parseFloat(this.DFRMin),
                  parseFloat(this.DFRStep)
                )

                break
              }
            } else if (this.rateRows[r].rider) {
              if (this.premiumIndexes[r] === undefined) {
                // if there's not an index slot for this row, push 0 as a starting index value
                this.premiumIndexes.push(0)
              }

              if (
                this.rateRows[r].personId === store.state.rates[idx].personId &&
                this.rateRows[r].productId ===
                  store.state.rates[idx].productId &&
                this.rateRows[r].planCodeId ===
                  store.state.rates[idx].planCodeId &&
                this.rateRows[r].rider.id === store.state.rates[idx].rider.id
              ) {
                // this stored rate selection appears to match to this row's person and product
                // now find the index into the premium amounts that matches the stored premium.

                for (
                  let m = 0;
                  m < this.rateRows[r].rider.coverages.length;
                  m++
                ) {
                  if (
                    this.rateRows[r].rider.coverages[m].PremiumPerWeek ===
                    store.state.rates[idx].premium
                  ) {
                    // the premiums match, update the index of the slider.
                    this.premiumIndexes[r] = m
                    break
                  }
                }

                break
              }
            }
          }
        }
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue setStoredRate')
        this.error = true
        // console.log(e)
        this.errors.push(e)
      }
    },
    saveRates() {
      // save the selected premiums and weekly premium preference to the store
      try {
        if (this.rateRows) {
          store.commit('clearRates')

          let LifePremium = 0
          let DFRPremium = 0

          for (let idx = 0; idx < this.rateRows.length; idx++) {
            if (
              this.rateRows[idx].rider &&
              this.rateRows[idx].rider.type.toUpperCase() === 'DFR'
            ) {
              let rate = {
                personId: this.rateRows[idx].personId,
                personType: this.rateRows[idx].personType,
                name: this.rateRows[idx].name,
                displayName: this.rateRows[idx].displayName,
                cancer: this.rateRows[idx].cancer,
                description: this.rateRows[idx].description,
                faceAmt: 0,
                premium:
                  this.DFRPremiumAmount(
                    this.premiumIndexes[idx],
                    parseFloat(this.DFRMin),
                    parseFloat(this.DFRStep)
                  ) > 0
                    ? this.DFRPremiumAmount(
                        this.premiumIndexes[idx],
                        parseFloat(this.DFRMin),
                        parseFloat(this.DFRStep)
                      )
                    : this.DFRMin,
                productId: this.rateRows[idx].productId,
                planCodeId: this.rateRows[idx].planCodeId,
                rider: this.rateRows[idx].rider,
              }

              DFRPremium += parseFloat(rate.premium)

              store.commit('addRate', rate)
            } else {
              // rateRows[n] is row n in the rates table (the 'sliders' data grid table)
              // rateRows[n].premiumAmounts is the range of slider values for row n in that table
              // premiumIndexes[n] is the selected slider value of row n, which is an index of the premiumAmounts array, not an amount.
              // rateRows[n].premiumAmounts[premiumIndexes[n]].PremiumPerWeek is the premium for the nth row's slider.
              // rateRows[n].premiumAmounts[premiumIndexes[n]].FaceAmount is the face amount for the nth row's slider.

              // (given that all data is populated - defaults are used below when applicable)

              let rate = {
                personId: this.rateRows[idx].personId,
                personType: this.rateRows[idx].personType,
                name: this.rateRows[idx].name,
                displayName: this.rateRows[idx].displayName,
                cancer: this.rateRows[idx].cancer,
                description: this.rateRows[idx].description,
                faceAmt: (
                  this.rateRows[idx].premiumAmounts === undefined
                    ? 0
                    : this.rateRows[idx].premiumAmounts[
                        this.premiumIndexes[idx] === undefined
                          ? 0
                          : this.premiumIndexes[idx]
                      ]
                )
                  ? this.rateRows[idx].premiumAmounts === undefined
                    ? 0
                    : this.rateRows[idx].premiumAmounts[
                        this.premiumIndexes[idx] === undefined
                          ? 0
                          : this.premiumIndexes[idx]
                      ].FaceAmount
                  : 0,
                premium: (
                  this.rateRows[idx].cancer && this.rateRows[idx].cancer != ''
                    ? 0
                    : this.rateRows[idx].premiumAmounts === undefined
                    ? 0
                    : this.rateRows[idx].premiumAmounts[
                        this.premiumIndexes[idx] === undefined
                          ? 0
                          : this.premiumIndexes[idx]
                      ]
                )
                  ? this.rateRows[idx].premiumAmounts === undefined
                    ? 0
                    : this.rateRows[idx].premiumAmounts[
                        this.premiumIndexes[idx] === undefined
                          ? 0
                          : this.premiumIndexes[idx]
                      ].PremiumPerWeek
                  : 0,

                productId: this.rateRows[idx].productId,
                planCodeId: this.rateRows[idx].planCodeId,
              }

              if (this.rateRows[idx].rider) {
                rate.rider = this.rateRows[idx].rider
              }

              if (this.rateRows[idx].product) {
                rate.product = this.rateRows[idx].product
              }

              if (this.rateRows[idx].product.name.indexOf('Cancer') < 0) {
                LifePremium += parseFloat(rate.premium)
              }

              store.commit('addRate', rate)
            }
          }

          store.commit('setTotalDFRPremium', DFRPremium)
          store.commit('setTotalLifePremium', LifePremium)
          store.commit('setWeeklyPremiumPreference', this.budget)
        }
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue saveRates')
        this.error = true
        // console.log(e)
        this.errors.push(e)
      }
    },
    checkForProductAvailibility() {
      // determine if any products are available to be displayed on the product page
      // based on applicant ages (and possibly by additional future criteria)
      try {
        let atLeastOneProductAvailable = false

        if (!this.eligibleProducts || this.eligibleProducts.length <= 0)
          return true

        for (let idx = 0; idx < this.storedPersons.length; idx++) {
          for (let j = 0; j < this.eligibleProducts.length; j++) {
            if (
              !this.productExcludedForInsured(
                this.storedPersons[idx],
                this.eligibleProducts[j],
                undefined
              )
            ) {
              atLeastOneProductAvailable = true
              break
            }
          }

          if (atLeastOneProductAvailable) break
        }

        if (atLeastOneProductAvailable) {
          return false
        } else {
          return true
        }
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue checkForProductAvailability'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
      }
    },
    riderAgeExcluded(person, rider) {
      try {
        let exclude = false

        let types = ['employee', 'spouse', 'child']

        if (rider) {
          if (rider.eligibility) {
            for (let type of types) {
              if (person.type.toLowerCase() === type.toLowerCase()) {
                if (rider.eligibility[type]) {
                  let conditions = rider.eligibility[type].condition.split('|')

                  if (conditions.findIndex((c) => c.trim() === 'na') >= 0) {
                    exclude = true
                  } else if (
                    conditions.findIndex((c) => c.trim() === 'age') >= 0
                  ) {
                    if (rider.eligibility[type].minAgeDays) {
                      if (
                        person.ageInDays &&
                        person.ageInDays < rider.eligibility[type].minAgeDays
                      )
                        exclude = true
                    }
                    if (rider.eligibility[type].maxAgeDays) {
                      if (
                        person.ageInDays &&
                        person.ageInDays > rider.eligibility[type].maxAgeDays
                      )
                        exclude = true
                    }
                    if (rider.eligibility[type].maxAgeYears) {
                      if (person.age > rider.eligibility[type].maxAgeYears)
                        exclude = true
                    }
                    if (rider.eligibility[type].minAgeYears) {
                      if (person.age < rider.eligibility[type].minAgeYears)
                        exclude = true
                    }
                  }
                }
              }
            }
          }
        }

        return exclude
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue riderAgeExcluded'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return false
      }
    },
    productExcludedForInsured(person, product, rider) {
      // determine if the product (passed in as 'product') can be displayed for the person
      // in question (passed in as 'person') based on the product's (really plan code's)
      // age requirements
      try {
        let exclude = false

        if (product.minAgeYears) {
          if (person.age < product.minAgeYears) {
            exclude = true
          }
        }

        if (product.maxAgeYears) {
          if (person.age > product.maxAgeYears) {
            exclude = true
          }
        }

        if (product.minAgeDays) {
          if (person.ageInDays && person.ageInDays < product.minAgeDays) {
            exclude = true
          }
        }

        if (product.maxAgeDays) {
          if (person.ageInDays && person.ageInDays > product.maxAgeDays) {
            exclude = true
          }
        }

        let types = ['employee', 'spouse', 'child']

        if (rider && this.riderAgeExcluded(person, rider)) exclude = true

        if (rider) {
          if (rider.requirements) {
            for (let type of types) {
              if (person.type.toLowerCase() === type.toLowerCase()) {
                if (rider.requirements[type]) {
                  let conditions = rider.requirements[type].condition.split('|')

                  if (
                    conditions.findIndex((c) => c.trim() === 'exclude') >= 0
                  ) {
                    for (let excludedBy of rider.requirements[type]
                      .excludedBy) {
                      if (excludedBy.startsWith('age')) {
                        if (rider.requirements[type][excludedBy]) {
                          let e = excludedBy.split('_')
                          let exclusionByAgePersonType = e[1]

                          let atLeastOneInAgeRange = false

                          let people = this.storedPersons.filter(
                            (s) =>
                              s.type.toLowerCase() ===
                              exclusionByAgePersonType.toLowerCase()
                          )

                          for (let person of people) {
                            let inAgeRange = true

                            if (
                              rider.requirements[type][excludedBy].minAgeDays
                            ) {
                              if (
                                person.ageInDays &&
                                person.ageInDays <
                                  rider.requirements[type][excludedBy]
                                    .minAgeDays
                              )
                                inAgeRange = false
                            }
                            if (
                              rider.requirements[type][excludedBy].maxAgeDays
                            ) {
                              if (
                                person.ageInDays &&
                                person.ageInDays >
                                  rider.requirements[type][excludedBy]
                                    .maxAgeDays
                              )
                                inAgeRange = false
                            }
                            if (
                              rider.requirements[type][excludedBy].maxAgeYears
                            ) {
                              if (
                                person.age >
                                rider.requirements[type][excludedBy].maxAgeYears
                              )
                                inAgeRange = false
                            }
                            if (
                              rider.requirements[type][excludedBy].minAgeYears
                            ) {
                              if (
                                person.age <
                                rider.requirements[type][excludedBy].minAgeYears
                              )
                                inAgeRange = false
                            }

                            if (inAgeRange) atLeastOneInAgeRange = true
                          }

                          if (!atLeastOneInAgeRange) {
                            exclude = true
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        types = ['employee', 'spouse', 'child']
        for (let type of types) {
          if (person.type.toLowerCase() === type) {
            if (product.eligibility) {
              if (product.eligibility[type]) {
                let conditions = product.eligibility[type].condition.split('|')

                if (conditions.findIndex((c) => c.trim() === 'na') >= 0) {
                  exclude = true
                }
              }
            }
          }
        }

        if (exclude) {
          // remove the product from the selections on the off chance
          // that the applicant has gone back and changed the DOB
          // on a possible insured after making selections

          this.removeSelection(
            person,
            product.productId,
            product.planCodeId,
            rider
          )

          // exclude the product
          return true
        } else {
          return false
        }
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue productExcludedForInsured'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return false
      }
    },
    DFRIndex(premium, min, step) {
      try {
        let counter = 0

        for (let i = min; i < premium; i += step) {
          counter++
        }

        return counter
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue DFRIndex')
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return 0
      }
    },
    DFRPremiumAmount(val, min, step) {
      try {
        let max = this.nonDFRTotalPremiums()

        let premiumArray = []

        for (let i = min; i <= max; i += step) {
          premiumArray.push(i)
        }

        if (val === undefined || val < 0) return min
        if (val >= premiumArray.length)
          return premiumArray[premiumArray.length - 1]

        return premiumArray[val]
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue DFRPremiumAmount'
        )
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return 0
      }
    },
    premiumAmount(item, val) {
      // The premium amount associated with the selected index on the rates slider
      try {
        // item is the rates row item
        if (item === undefined) return 0

        // item.premiumAmounts is the array of rates/premiums and face amounts
        // pulled from the rates api, if it's undefined, return 0 as we don't have
        // a valid premium to supply.
        if (item.premiumAmounts === undefined) return 0

        if (item.premiumAmounts[val] === undefined) return 0

        // val is the slider's value, which stores an index into the premiums amount array
        // where the currently selected premium is stored.
        return item.premiumAmounts[val].PremiumPerWeek
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue premiumAmount')
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return 0
      }
    },
    faceAmount(item, index) {
      // The face amount associated with the selected premium index of the rates slider
      try {
        if (item === undefined) return 0

        // item.premiumAmounts is the array of rates/premiums and face amounts
        // pulled from the rates api, if it's undefined, we don't have a face amount to supply.
        if (item.premiumAmounts === undefined) return 0

        // this.premiumIndexes[index] stores the index value of the rate indexed rate slider
        // the slider does not save the premium but an index into the premiums array.
        // if it's undefined, return the first of the face amounts (for the lowest/default premium)
        if (this.premiumIndexes[index] === undefined) return 0

        if (item.premiumAmounts[this.premiumIndexes[index]] === undefined)
          return 0

        return item.premiumAmounts[this.premiumIndexes[index]].FaceAmount
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue faceAmount')
        this.error = true
        // console.log(e)
        this.errors.push(e)
        return 0
      }
    },
    setMaxTab(idx) {
      // Store the maximum tab visited by the applicant so far
      // This is used to prevent the applicant from jumping steps
      // accidentally when clicking on the stepper headings.
      try {
        if (idx > store.state.maxTab) {
          store.commit('setMaxTab', idx)
        }
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue setMaxTab')
        store.commit('setMaxTab', 2)
      }
    },
    buildCancerAppBuckets() {
      try {
        let applicants = []

        // for each selected product
        for (let idx = 0; idx < this.selections.length; idx++) {
          // find the person & product associated with the product selection
          let personAndProduct = this.findSelectionInfo(this.selections[idx])

          if (!personAndProduct) {
            continue
          }

          if (personAndProduct.product.name.indexOf('Cancer') < 0) {
            continue
          }

          applicants.push(personAndProduct)
        }

        let buckets = []
        let childBucketIndex = 1

        if (applicants.length) {
          buckets[0] = {
            applicant: undefined,
            spouse: undefined,
            children: undefined,
          }
        }

        for (let applicant of applicants) {
          if (applicant.person.type.toLowerCase() == 'child') {
            if (applicant.person.age >= 19) {
              buckets[childBucketIndex] = {
                applicant: applicant,
                spouse: undefined,
                children: undefined,
              }
              childBucketIndex++
            } else {
              if (buckets[0].children == undefined) buckets[0].children = []
              buckets[0].children.push(applicant)
            }
          } else if (applicant.person.type.toLowerCase() == 'spouse') {
            buckets[0].spouse = applicant
          } else if (
            applicant.person.type.toLowerCase() == 'employee' ||
            applicant.person.type.toLowerCase == 'applicant'
          ) {
            buckets[0].applicant = applicant
          }
        }

        for (let bucket of buckets) {
          if (
            bucket.applicant != undefined &&
            bucket.spouse == undefined &&
            bucket.children == undefined
          ) {
            bucket.oldestApplicant = bucket.applicant
            bucket.plan = 'ind'
          } else {
            let temp = []

            if (bucket.applicant) temp.push(bucket.applicant)
            if (bucket.spouse) temp.push(bucket.spouse)
            if (bucket.children) temp.push(...bucket.children)

            let oldestDOB = new Date()

            for (let t of temp) {
              let DOBDate = this.parseDate(t.person.birthdate)
              if (DOBDate) {
                let dob = new Date(DOBDate + 'T00:00:00')

                if (dob < oldestDOB) {
                  bucket.oldestApplicant = t
                  oldestDOB = dob
                }
              }
            }

            if (bucket.applicant && bucket.spouse) {
              bucket.plan = 'fam' // family
            } else if (
              (bucket.applicant || bucket.spouse) &&
              bucket.children &&
              bucket.children.length > 0
            ) {
              bucket.plan = 'parent' // single parent
            } else if (bucket.children && bucket.children.length > 0) {
              bucket.plan = 'parent' // also single parent, despite no parents on plan
            } else {
              bucket.plan = 'ind' // individual
            }
          }
        }

        if (applicants[0]) {
          for (let bucket of buckets) {
            let planCodeCrosswalk = applicants[0].product.planCodeCrosswalk
            bucket.planCodeId = planCodeCrosswalk[bucket.plan]
          }
        }

        return buckets
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue buildCancerAppBuckets'
        )
        // console.log(e)
        this.errors.push(e)
        this.error = true
        return []
      }
    },
    getRates() {
      try {
        // Get the rates for the sliders from the rates api
        // if no products have been selected, stop.

        this.ratesLoaded = false
        let promises = []

        if (this.e1 < 3) return

        if (
          !this.selections ||
          this.selections.length < 1 ||
          this.selections[0] === undefined
        )
          return

        let cancerAppBuckets = this.buildCancerAppBuckets()
        this.$store.commit('setCancerAppBuckets', cancerAppBuckets)

        // for each selected product
        for (let idx = 0; idx < this.selections.length; idx++) {
          // find the person & product associated with the product selection
          let personAndProduct = this.findSelectionInfo(this.selections[idx])

          if (!personAndProduct) {
            continue
          }

          let skipThis = false

          if (personAndProduct.product.name.indexOf('Cancer') >= 0) {
            skipThis = false
          } else {
            // check if we already have the applicable product/plan/issue age
            // in the ratesTable, if so, let's skip making the call again for this slider.
            for (let x = 0; x < this.ratesTable.length; x++) {
              if (
                this.ratesTable[x][0] &&
                this.ratesTable[x][0].IssueAge == personAndProduct.person.age &&
                this.ratesTable[x][0].Product_ID ==
                  personAndProduct.product.productId &&
                this.ratesTable[x][0].PlanCode_ID ==
                  personAndProduct.product.planCodeId
              ) {
                skipThis = true
              }
            }
          }

          if (personAndProduct.rider && personAndProduct.rider.id)
            skipThis = true

          if (!skipThis) {
            // Make the rates call.

            if (personAndProduct.product.name.indexOf('Cancer') >= 0) {
              let checkApplicant = false
              let planToCheck = ''

              for (let bucket of cancerAppBuckets) {
                if (
                  bucket.oldestApplicant.person.id == personAndProduct.person.id
                ) {
                  checkApplicant = true
                  planToCheck = bucket.planCodeId
                }
              }

              if (checkApplicant) {
                promises.push(
                  AWS_HTTP.get('product-rates', {
                    params: {
                      issueage: personAndProduct.person.age,
                      productid: personAndProduct.product.productId,
                      plancodeid: personAndProduct.product.planCodeId,
                      gender: personAndProduct.person.sex,
                      planType: planToCheck,
                    },
                  })
                    .then((response) => {
                      let temp = []

                      temp.push(response.data)

                      for (let idx = 0; idx < temp.length; idx++) {
                        // sort the product/plan/age results by premium
                        // then push onto the ratesTable (which is actually an
                        // array of all the rate arrays for the sliders)

                        this.ratesTable.push(
                          temp[idx].sort(function (a, b) {
                            return (
                              parseFloat(a.PremiumPerWeek) -
                              parseFloat(b.PremiumPerWeek)
                            )
                          })
                        )
                      }
                    })
                    .catch((e) => {
                      log(
                        e.toString(),
                        true,
                        'tmk-products-and-questions.vue getRates'
                      )
                      // console.log(e)
                      this.errors.push(e)
                      this.error = true
                    })
                )
              }
            } else {
              promises.push(
                AWS_HTTP.get('product-rates', {
                  params: {
                    issueage: personAndProduct.person.age,
                    productid: personAndProduct.product.productId,
                    plancodeid: personAndProduct.product.planCodeId,
                  },
                })
                  .then((response) => {
                    let temp = []

                    temp.push(response.data)

                    for (let idx = 0; idx < temp.length; idx++) {
                      // sort the product/plan/age results by premium
                      // then push onto the ratesTable (which is actually an
                      // array of all the rate arrays for the sliders)

                      this.ratesTable.push(
                        temp[idx].sort(function (a, b) {
                          return (
                            parseFloat(a.PremiumPerWeek) -
                            parseFloat(b.PremiumPerWeek)
                          )
                        })
                      )
                    }
                  })
                  .catch((e) => {
                    log(
                      e.toString(),
                      true,
                      'tmk-products-and-questions.vue getRates'
                    )
                    // console.log(e)
                    this.errors.push(e)
                    this.error = true
                  })
              )
            }
          }
        }

        if (promises.length == 0) this.ratesLoaded = true

        axios.all(promises).then(() => {
          this.ratesLoaded = true
          this.calculateRemaining()
          this.waitDialog = false
        })
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue getRates')
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
    relatedProductSelectedForPerson(rider, person) {
      try {
        if (rider && rider.productId) {
          if (this.selections) {
            for (let sel of this.selections) {
              if (sel.endsWith('|')) {
                let personAndProduct = this.findSelectionInfo(sel)

                if (
                  personAndProduct.person.id === person.id &&
                  personAndProduct.product.productId == rider.productId &&
                  rider.planCodes.findIndex(
                    (p) => p == personAndProduct.product.planCodeId
                  ) >= 0
                )
                  return true
              }
            }
          }

          return false
        }

        return true
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue relatedProductSelectedForPerson'
        )
        // console.log(e)
        this.errors.push(e)
        this.error = true
        return false
      }
    },
    relatedProductSelected(rider) {
      try {
        if (rider && rider.productId) {
          if (this.selections) {
            for (let sel of this.selections) {
              if (sel.endsWith('|')) {
                let personAndProduct = this.findSelectionInfo(sel)

                if (
                  personAndProduct.product.productId == rider.productId &&
                  rider.planCodes.findIndex(
                    (p) => p == personAndProduct.product.planCodeId
                  ) >= 0
                )
                  return true
              }
            }
          }

          return false
        }

        return true // not a rider
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue relatedProductSelected'
        )
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
    switchStep(tabIndex) {
      // used to switch between steps of the stepper

      // If no products are available, clear the selection
      // array and save to store. This prevents a bug
      // that allowed users to change a potential insured's DOB
      // and then skip steps in the products/questions flow.
      try {
        if (this.noProductAvailibility) {
          if (this.e1 == 2) {
            this.selections = []
            this.saveSelectionsToStore()
            this.setMaxTab(2)
          }
          this.$store.commit('setProductsPage', this.e1)
          return
        }

        // if the tabIndex (requested tab) has been visited before (as indicated by
        // the maxTab being greater than or equal to the tabIndex), or the tabIndex
        // (requested tab) is the next tab in line, proceed, otherwise ignore the request.

        if (tabIndex <= store.state.maxTab || tabIndex <= this.e1 + 1) {
          if (this.e1 == 2) {
            // Product Selections Tab

            if (this.selections && this.selections.length > 0) {
              // selections have been made, save to the store
              // and move on

              // let unselectedPerson = false

              // for (let person of this.storedPersons) {
              //   let found = false
              //   for (let idx = 0; idx < this.selections.length; idx++) {
              //     if (this.selections[idx].indexOf(person.id) >= 0) {
              //       found = true
              //     }
              //   }
              //   if (!found) {
              //     unselectedPerson = true
              //   }
              // }

              this.saveSelectionsToStore()

              // if (unselectedPerson && this.$store.state.maxTab == 2) {
              //   this.currentTabIndex = tabIndex
              //   this.warningDialog = true
              // } else

              {
                this.setMaxTab(tabIndex)
                this.e1 = tabIndex
              }
            } else {
              // update the store, but
              // stay on the page until the applicant makes a selection
              this.saveSelectionsToStore()
            }
          } else if (this.e1 == 3) {
            // Replacement and Health Questions Tab

            if (
              (tabIndex < this.e1 && this.save()) ||
              (tabIndex > this.e1 && this.validateAndSaveQuestions())
            ) {
              this.setMaxTab(tabIndex)

              this.e1 = tabIndex
              // if (tabIndex == 4) {
              //   this.waitDialog = true
              //   this.getRates()
              // }
            }
          } else if (this.e1 === 4) {
            // Rate Calculator Tab

            this.saveRates()

            if (
              tabIndex < this.e1 ||
              (this.$refs.payPeriodsForm.validate() &&
                this.otherPayPeriodRules === '')
            ) {
              store.commit('setPayPeriodsRadio', this.payPeriodsRadio)
              store.commit('setPaycheckDeductions', this.estimatedDeduction)
              store.commit('setPayPeriodsOther', this.payPeriodsOther)
              this.setMaxTab(tabIndex)
              this.e1 = tabIndex
            }
          } else {
            // Rate Summary and Next Steps Tabs (5 and 6)

            this.setMaxTab(tabIndex)
            this.e1 = tabIndex
          }

          // if we've just moved to tab 3 based on the above logic,
          // update its sliders with the stored rates:
          if (this.e1 === 4) {
            this.waitDialog = true
            this.getRates()
            this.setStoredRate()
          }

          window.scrollTo(0, 0)
        }

        this.$store.commit('setProductsPage', this.e1)
        // console.log(
        //   'products page set to : ' + this.$store.state.productsPage.toString()
        // )
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue switchStep')
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
    previousClick() {
      // clear the product selections from the store and
      // save the current UI selections to the store

      // store.commit('clearSelections')

      // for (let idx = 0; idx < this.selections.length; idx++) {
      //   store.commit('addSelection', this.selections[idx])
      // }

      // this.saveSelectionsToStore()
      try {
        if (this.e1 == 2) {
          this.saveSelectionsToStore()
        } else if (this.e1 == 3) {
          this.save()
        } else if (this.e1 === 4) {
          this.saveRates()
        }

        // alert StartApplication.vue to show the demographics section
        // again

        EventBus.$emit('showDemographics')
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue previousClick')
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
    continueClick() {
      // alert the StartApplication.vue to show the submission
      // page and redirect to DocuSign.

      EventBus.$emit('showSubmit')
    },
    omit(question) {
      // if this question's id shows up in the omitQuestions array, do not
      // ask it.

      try {
        if (
          this.omitQuestions.find((q) => q.questionId === question.questionId)
        ) {
          question.radioBtnAnswer = undefined
          return true
        }
        return false
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue omit')
        // console.log(e)
        this.errors.push(e)
        this.error = true
        return false
      }
    },
    validateAndSaveQuestions() {
      // make sure the applicant has answered all applicable questions
      // then save them

      // returning false prevents switchStep from navigating off the page
      // if validation fails.
      try {
        if (this.$refs.form.validate()) {
          this.save()
          return true
        } else {
          return false
        }
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue validateAndSaveQuestions'
        )
        // console.log(e)
        this.errors.push(e)
        this.error = true
        return false
      }
    },
    prePopulate() {
      try {
        // populate questions with previous answers, if any
        for (let i = 0; i < this.questions.length; i++) {
          let storedQuestion = store.getters.getQuestionById(
            this.questions[i].questionId
          )

          if (storedQuestion) {
            this.questions[i].radioBtnAnswer = storedQuestion.radioBtnAnswer
          }
        }
        for (let i = 0; i < this.questions.length; i++) {
          // check if any questions should be added back
          // into the omitQuestions list
          // based on previously populated answers

          this.checkDependencies(this.questions[i])
        }
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue prePopulate')
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
    save() {
      // Save the health/replacement questions to the store.
      try {
        for (let j = 0; j < this.questions.length; j++) {
          let questionObj = {
            questionId: this.questions[j].questionId,
            radioBtnAnswer: this.questions[j].radioBtnAnswer,
            template: this.questions[j].associatedTemplate,
          }

          let questionExists = store.getters.getQuestionById(
            questionObj.questionId
          )

          if (questionExists) {
            store.commit('updateQuestion', questionObj)
          } else {
            store.commit('addQuestion', questionObj)
          }
        }
        return true
      } catch (e) {
        log(e.toString(), true, 'tmk-products-and-questions.vue save')
        // console.log(e)
        this.errors.push(e)
        this.error = true
        return false
      }
    },
    checkDependencies(question) {
      // if the answer to this question does not match the dependencies' answer
      // (usually if the answer is 'no') then add the question id of
      // the question to omit to the omitQuestions array (with this question's id
      // as the originatingQuestionId so that if its answer changes, the dependency
      // can be removed) (The dependent question does not need to be asked because
      // the primary question was answered 'no'.)
      if (!question.radioBtnAnswer || !question.dependencyCondition) return

      try {
        if (
          question.radioBtnAnswer.toLowerCase() !=
          question.dependencyCondition.toLowerCase()
        ) {
          if (question.dependencies.length > 0) {
            for (let idx = 0; idx < question.dependencies.length; idx++) {
              let newOmitQuestion = {
                originatingQuestionId: question.questionId,
                questionId: question.dependencies[idx],
              }

              this.omitQuestions.push(newOmitQuestion)
            }
          }
        } else {
          // the answer does match the dependencies' answer (usually
          // this means the applicant answered 'yes' or changed the answer
          // to 'yes') so remove the questions dependent question IDs from
          // the omitQuestions array. This will ensure the dependent question is
          // asked when the primary question's answer is 'yes'.

          let idx = 0

          while (idx >= 0) {
            idx = this.omitQuestions.findIndex(
              (q) => q.originatingQuestionId === question.questionId
            )

            if (idx >= 0) {
              this.omitQuestions.splice(idx, 1)
            }
          }
        }
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue checkDependencies'
        )
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
    saveSelectionsToStore() {
      try {
        // clear the store's product selections and save the new selections
        // from the UI

        store.commit('clearSelections')

        for (let person of this.storedPersons) {
          for (let idx = 0; idx < this.selections.length; idx++) {
            if (this.selections[idx].indexOf(person.id) >= 0) {
              store.commit('addSelection', this.selections[idx])
            }
          }
        }
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue saveSelectionsToStore'
        )
        // console.log(e)
        this.errors.push(e)
        this.error = true
      }
    },
    findSelectionInfo(selection) {
      let pAndp = this.selectionInfoCache.find((s) => s.sel === selection)
      if (pAndp) {
        // console.log(pAndp)
        return pAndp.pAndP
      }

      // because the selections array is updated behind the scenes by the checkbox control,
      // the data in it apparently has to be flat for the control to work correctly

      // the product id, plan code id and person id are stored in the selections array
      // as productId_planCodeId_personId, with each ID separated from the others by an underscore.

      // split the current selection by underscore into its respective parts, then return the corresponding
      // person from the storedPerson's array (alias for store data 'applicableIndividuals'),
      // and the corresponding product/plan from the
      // eligibleProducts array (alias for store data 'eligibileProducts').
      try {
        let details = selection.split('|')
        let productId = -1
        let planCodeId = -1
        let personId = -1
        let riderId = undefined

        if (details.length >= 3) {
          productId = details[0]
          planCodeId = details[1]
          personId = details[2]
        }

        if (details.length >= 4) {
          riderId = details[3]
        }

        if (riderId) {
          // console.log(riderId)

          for (let idx = 0; idx < this.storedPersons.length; idx++) {
            for (let j = 0; j < this.eligibleProducts.length; j++) {
              for (let rider of this.riders) {
                if (
                  productId == this.eligibleProducts[j].productId &&
                  personId == this.storedPersons[idx].id &&
                  riderId == rider.id
                ) {
                  let personAndProduct = {
                    person: JSON.parse(JSON.stringify(this.storedPersons[idx])),
                    product: {
                      name: rider.name,
                      id: -1,
                      excludesProducts: [],
                    },
                    rider: JSON.parse(JSON.stringify(rider)),
                  }

                  this.selectionInfoCache.push({
                    sel: selection,
                    pAndP: JSON.parse(JSON.stringify(personAndProduct)),
                  })

                  //     this.$store.commit(
                  //   'setselectionsInfoCache',
                  //   this.selectionInfoCache
                  // )

                  // console.log('pushed')
                  // console.log(this.selectionInfoCache)

                  return personAndProduct
                }
              }
            }
          }
        }

        for (let idx = 0; idx < this.storedPersons.length; idx++) {
          for (let j = 0; j < this.eligibleProducts.length; j++) {
            if (
              productId == this.eligibleProducts[j].productId &&
              planCodeId == this.eligibleProducts[j].planCodeId &&
              personId == this.storedPersons[idx].id
            ) {
              let personAndProduct = {
                person: this.storedPersons[idx],
                product: this.eligibleProducts[j],
                rider: undefined,
              }

              this.selectionInfoCache.push({
                sel: selection,
                pAndP: JSON.parse(JSON.stringify(personAndProduct)),
              })

              // this.$store.commit(
              //   'setselectionsInfoCache',
              //   this.selectionInfoCache
              // )

              return personAndProduct
            }
          }
        }

        return undefined
      } catch (e) {
        log(
          e.toString(),
          true,
          'tmk-products-and-questions.vue findSelectionInfo'
        )
        this.errors.push(e)
        this.error = true
        return undefined
      }
    },
  },
}
</script>

<style>
.smallPrint {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: smaller;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
}
.myTable .v-table thead {
  border-bottom: none;
}
.myTable .v-table tbody {
  border-bottom: none;
  background-color: white;
  color: rgba(0, 0, 0, 0.54);
  text-align: center !important;
}
.theme--light.v-table thead th {
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: bold;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 15px;
}
.v-input--selection-controls__input {
  align-items: center !important;
  justify-content: center !important;
}
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px !important;
  margin-top: 10px;
}
.commonFont {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.54);
  text-align: left;
  font-weight: bold;
}

.productFont {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  text-align: left;
  font-weight: bold;
}
.riderFont {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  text-align: left;
  margin-left: 15px;
  font-style: italic;
}

.riderFontSm {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  text-align: left;
  font-style: italic;
}

.questionFont {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.54);
  text-align: left;
  font-weight: normal;
}
.indent {
  margin-left: 50px;
  margin-right: 20px;
}
.radioBtnPadding {
  margin-left: 25px;
}
.notice {
  font-style: italic;
  color: green;
}
.noProductsNotice {
  font-weight: bolder;
}
.faceAmount {
  color: green;
}
.remainingToSpend {
  font-size: 18px;
  color: darkslategrey;
}

.myTableSm .v-table thead {
  border-bottom: none;
}
.myTableSm .v-table thead > tr > th {
  white-space: normal;
}
.myTableSm .v-table tbody {
  border-bottom: none;
  background-color: white;
  color: rgba(0, 0, 0, 0.54);
}
.wrapper {
  display: flex;
}
.wrapper-inner {
  flex-basis: 100%;
}
.weeklyPremium {
  font-size: 20px;
}
.childRiderEligible {
  font-size: 40px;
  color: green;
}
.childRiderIneligible {
  font-size: 40px;
  color: red;
}
.v-icon:hover {
  cursor: pointer;
}
.v-stepper__header {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  flex-wrap: nowrap !important;
  justify-content: left;
}
.v-stepper__label {
  white-space: normal;
  display: inline-block !important;
}

.riderTable .v-table thead tr th {
  padding-left: 40px !important;
  font-size: 14px;
}
.riderTable .v-table tbody tr td {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-right: 0px !important;
  padding-left: 24px !important;
}

.riderTableSm .v-table thead tr th {
  font-size: 14px;
}
.riderTableSm .v-table tbody tr td {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-right: 0px !important;
}

.riderTableXs .v-table thead tr th {
  font-size: 14px;
  max-width: 300px;
}
.riderTableXs .v-table tbody tr td {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-right: 0px !important;
  max-width: 300px;
}
.productTableXs .v-table thead tr th {
  max-width: 300px;
  padding: 0px;
  padding-right: 10px;
}
.productTableXs .v-table tbody tr td {
  max-width: 300px;
  padding: 0px;
  padding-right: 10px;
}
.btn {
  border-radius: 0 !important;
}
.input-group {
  flex: 1 1 auto;
}
</style>
